const de = {
  common: {
    // Indicador global de datos simulados (MockDataBadge). Ver docs/contexto/decisiones.md D-8.
    mockData: 'Demodaten',
    mockDataHint: 'Der Recognition-Dienst ist noch nicht bereitgestellt: Dieser Bildschirm wird mit simulierten Daten aus der Anwendung selbst versorgt.',
    loading: 'Wird geladen...',
    error: 'Fehler',
    documentNotAvailable: 'Dieses Dokument ist derzeit nicht verfügbar. Das kann an deiner Sprache oder deiner Einheit liegen; wende dich an deinen Administrator, falls das Problem weiterhin besteht.',
    sessionExpiredMessage: 'Deine Sitzung ist abgelaufen. Speichere, was du kannst, und melde dich erneut an.',
    reload: 'Erneut anmelden',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    close: 'Schließen',
    download: 'Herunterladen',
    confirm: 'Bestätigen',
    search: 'Suchen',
    filter: 'Filtern',
    export: 'Exportieren',
    yes: 'Ja',
    no: 'Nein',
    back: 'Zurück',
    next: 'Weiter',
    submit: 'Absenden',
    darkMode: 'Dunkelmodus',
    lightMode: 'Hellmodus',
    languageMenuTitle: 'Sprache ändern',
    logout: 'Abmelden',
    pagerShow: 'Zeigen',
    pagerPerPage: 'pro Seite',
    pagerOf: 'von',
    viewCards: 'Kartenansicht',
    viewList: 'Listenansicht',
    collapse: 'Einklappen',
    expand: 'Ausklappen',
    previousPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    retry: 'Erneut versuchen',
    errorBoundaryTitle: 'Etwas ist schiefgelaufen',
    errorGeneric: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
    expandModal: 'Im Modal erweitern',
    resetToGlobal: 'Auf Global zurücksetzen',
    appName: 'Sigma Pulse',
  },
  nav: {
    home: 'Startseite',
    growth: 'Wachstum',
    admin: 'Verwaltung',
    executive: 'Führung',
    analytics: 'Analytik',
    switchDemoProfile: 'Demo-Profil wechseln',
    mobileNav: 'Hauptnavigation',
    fundamentals: 'Grundwerte',
    usersAdmin: 'Administratoren',
    recognitionSection: 'Anerkennungen',
    language: 'Sprache',
    collapseMenu: 'Menü einklappen',
    expandMenu: 'Menü ausklappen',
  },
  roles: {
    employee: 'Mitarbeiter',
    adminOU: 'Pulso OE-Admin',
    adminGlobal: 'General-Admin',
    adminPulso: 'Pulso-Admin',
    adminBrillamos: 'Brillamos-Admin',
    adminOUBrillamos: 'Brillamos OE-Admin',
  },
  access: {
    noPlatformTitle: 'Du hast keinen Zugriff auf die Kulturplattform',
    noPlatformDesc: 'Dein Konto hat keinen Zugriff auf ein Modul der Plattform. Wenn du glaubst, dass dies ein Fehler ist, wende dich an dein Human-Capital-Team.',
    profileErrorTitle: 'Dein Profil konnte nicht geladen werden',
    profileErrorDesc: 'Bei der Überprüfung deines Zugriffs ist ein Problem aufgetreten. Bitte versuche es in Kürze erneut; wenn das Problem weiterhin besteht, wende dich an dein Human-Capital-Team.',
  },
  // Pantalla «plataforma no disponible» (ServiceUnavailableView). Mismo texto que public/broadcast.html.
  serviceUnavailable: {
    label: 'Servicestatus',
    title: 'Die Plattform ist nicht verfügbar',
    message: 'Wir arbeiten daran, den Dienst wiederherzustellen. Bitte versuche es in einigen Minuten erneut.',
    retry: 'Erneut versuchen',
    changeLanguage: 'Sprache ändern',
  },
  platform: {
    teams: 'TEAMS',
  },
  survey: {
    title: 'Ausstehende Umfragen',
    pending: 'Ausstehend',
    completed: 'Abgeschlossen',
    expired: 'Abgelaufen',
    submit: 'Bewertung einreichen',
    skip: 'Überspringen',
    noObs: 'Keine Beobachtung',
    meeting: 'Besprechung',
    duration: 'Dauer',
    participants: 'Teilnehmer',
    simulateMeeting: 'Besprechungsende simulieren',
    thankYou: 'Vielen Dank für deine Bewertung!',
    evaluating: 'Bewertet',
    of: 'von',
    question: 'Frage',
    selectResponse: 'Antwort auswählen',
    nps: {
      question: 'Wie wahrscheinlich ist es, dass Sie die Zusammenarbeit mit dieser Person empfehlen?',
      detractor: 'Kritiker',
      passive: 'Passiv',
      promoter: 'Befürworter',
    },
    evaluateNow: 'Jetzt bewerten',
    postpone: 'Später',
    expires: 'Läuft ab',
    noSurveysPending: 'Keine ausstehenden Umfragen! Gute Arbeit.',
    weekCompleted: 'Wo.',
    likert: {
      always: 'Immer',
      usually: 'Meistens',
      sometimes: 'Manchmal',
      rarely: 'Selten',
      notObservable: 'Nicht beobachtbar',
    },
    questions: {
      listenedActivelyText: 'Hat diese Person aktiv zugehört und echtes Interesse gezeigt?',
      sharedKnowledgeText: 'Hat sie relevantes Wissen oder Erfahrungen während der Sitzung geteilt?',
    },
    completeSubtitle: 'Dein Feedback hilft, die Teamkultur zu stärken.',
    backToHome: 'Zurück zur Startseite',
    greetingMorning: 'Guten Morgen',
    greetingAfternoon: 'Guten Tag',
    greetingEvening: 'Guten Abend',
    pendingCountPre: 'Sie haben',
    pendingCountSingular: 'ausstehende Umfrage',
    pendingCountPlural: 'ausstehende Umfragen',
    allDoneTitle: 'Alles erledigt!',
    allDoneSubtitle: 'Sie haben keine ausstehenden Umfragen. Sie erscheinen hier nach Ihrem nächsten Meeting.',
    omit: 'Überspringen',
    omitSurvey: 'Umfrage überspringen',
    submitSuccess: 'Antworten gesendet',
    submitError: 'Fehler beim Senden — bitte erneut versuchen',
    omitSuccess: 'Umfrage übersprungen',
    omitError: 'Fehler — bitte erneut versuchen',
    unavailableError: 'Diese Umfrage ist nicht mehr verfügbar',
    kpi: {
      answered: 'Beantwortet',
      omitted: 'Übersprungen',
      streak: 'Serie',
      participation: 'Beteiligung',
    },
    growth: {
      title: 'Ihr Wachstum wartet auf Sie',
      message: 'Überprüfen Sie Ihre Ergebnisse, Trends und Entwicklungsbereiche im Wachstums-Dashboard.',
      cta: 'Mein Wachstum ansehen',
    },
    recognition: {
      title: 'Gemeinsam Strahlen',
      message: 'Würdigen Sie Ihre Kolleginnen und Kollegen und feiern Sie ihre Erfolge im Anerkennungsprogramm.',
      cta: 'Zur Anerkennung',
    },
    tips: {
      title: 'Tipps für Sie',
      based: 'Basierend auf deinem Durchschnittsscore',
      empty: 'Schließe mehr Umfragen ab, um personalisierte Tipps zu sehen',
      reconocer: 'Zum Anerkennen',
      crecer: 'Zum Wachsen',
      tipOfDay: 'Tipp des Tages',
    },
  },
  safe: {
    title: 'Mein Wachstum',
    subtitle: 'Deine kulturelle Entwicklung bei Sigma',
    sectionName: 'Mein Feedback',
    surveysAnswered: 'Beantwortete Umfragen',
    score: 'Dein Score',
    evolution: 'Deine Entwicklung',
    evolutionSub: 'Ihre persönliche Reise — nur Sie, ohne Vergleiche',
    radarTitle: 'Dein Profil nach Grundwert',
    radarSub: 'Sie heute vs Sie vor 3 Monaten',
    fundamentals: 'Grundwerte',
    fundamentalsChart: 'Dein Feedback nach Grundwert',
    fundamentalsChartSub: 'Wo Sie bei jedem stehen — klicken Sie auf einen Balken für Details',
    behaviors: 'Verhaltensweisen',
    kudos: 'Anerkennungen',
    kudosTitle: 'Zum Anerkennen — was Sie am meisten einbringen',
    kudosSub: 'Was deine Kollegen diesen Monat am meisten an dir beobachten',
    actions: 'Aktionsplan',
    omissions: 'Auslassungen',
    period: 'Zeitraum',
    received: 'Empfangen',
    sent: 'Gesendet',
    areaAverage: 'Bereichsdurchschnitt',
    today: 'Heute (letzte {{days}} Tage)',
    threeMonthsAgo: 'Vor 3 Monaten ({{days}}-Tage-Fenster)',
    detail: 'Detail',
    profileTitle: 'Dein kulturelles Profil in Worten',
    profileSub: 'Verhaltensweisen, keine Zahlen',
    basedOn: 'Basiert auf {{count}} anonymen Feedbacks',
    level0: 'Anfänger',
    level1: 'In Entwicklung',
    level2: 'Konsistent',
    level3: 'Vorbild',
    level0desc: 'Wartet darauf, dass andere Probleme lösen oder Hindernisse beseitigen.',
    level1desc: 'Versucht Hindernisse anzugehen, gibt aber schnell auf oder eskaliert zu früh.',
    level2desc: 'Ergreift die Initiative, um Hindernisse zu beseitigen und Lösungen zu finden, die Fortschritte ermöglichen.',
    level3desc: 'Inspiriert andere, die Initiative zu ergreifen, und schafft ein Umfeld, in dem das Überwinden von Blockaden eine gemeinsame Verantwortung ist.',
    levelAbbr0: 'Anfang',
    levelAbbr1: 'In Entw.',
    levelAbbr2: 'Konsist.',
    levelAbbr3: 'Vorbild',
    todayLabel: 'Heute',
    pointsInMonths: 'Punkte in {{n}} Monaten',
    monthsWithFeedback: 'Monate mit Feedback',
    journeyLoading: 'Deine Entwicklung wird geladen…',
    journeyEmpty: 'Es gibt noch nicht genug Verlauf, um deine Entwicklung darzustellen. Du brauchst mindestens zwei Monate mit Feedback.',
    journeyChartLabel: 'Entwicklung deines Durchschnitts Monat für Monat',
    thisMonth: 'diesen Monat',
    headingToLevel: 'Auf dem Weg zu {{level}}',
    maxLevel: 'Höchstes Level!',
    narrativeStrength: 'Was du am meisten beiträgst und Anerkennung verdient ist <strong>{{fund}}</strong> — du befindest dich auf Stufe <strong>{{level}}</strong>.',
    narrativeConsistency: 'Du zeigst auch Beständigkeit in {{others}}.',
    narrativeProgress: 'In den letzten 3 Monaten hast du Fortschritte gemacht — dein Profil zeigt Wachstum.',
    narrativeStable: 'Dein Profil ist in den letzten 3 Monaten stabil geblieben — das spricht für Beständigkeit.',
    narrativeVariation: 'Dein Profil hat in den letzten Monaten leicht variiert. Schwankungen sind normal und definieren dich nicht.',
    narrativeNextLevel: 'Dein nächstes Wachstumslevel liegt in <strong>{{fund}}</strong>. Der nächste Schritt ist, Level {{level}} zu erreichen — unten schlagen wir eine konkrete Aktion vor.',
    act01: 'Anerkennung — wie andere Sie sehen',
    act02: 'Fortschritt — wie Sie sich entwickelt haben',
    act03: 'Richtung — dein nächster Schritt',
    reinforces: 'STÄRKT',
    tryToday: 'Ich probiere es heute',
    committed: 'Ich verpflichte mich heute!',
    defaultChallenge: 'Üben Sie heute einen Grundwert',
    defaultChallengeDesc: 'Wählen Sie eine Micro-Aktion und setzen Sie sie in Ihrem nächsten Meeting um.',
    clickDetail: 'Klick für Details',
    nextLevel: 'NÄCHSTE STUFE',
    growthTitle: 'UM WEITER ZU WACHSEN',
    growthSub: 'Empfehlungen basierend auf deinem Feedback',
    feedbacks: 'Feedbacks',
    peers: 'Kollegen',
    givenTitle: 'Meine Teilnahme beim Geben von Feedback',
    givenSub: 'Feedback das Sie diesen Monat geteilt haben',
    footerPrivacy: 'Alles Feedback ist anonym. Niemand kann sehen wer es dir gegeben hat.',
    footerHeart: 'Denke daran: Feedback ist ein Geschenk. Diese Daten spiegeln Momente in Meetings wider.',
    personSingular: 'Person',
    personsPlural: 'Personen',
    trend: {
      up: 'Dein Profil zeigt Wachstum',
      down: 'Kleine Variation — das ist normal',
      stable: 'Stabiles Profil — das ist Konsistenz',
    },
    empty: {
      title: 'Lerne die Fundamentals kennen',
      desc: 'Du hast noch nicht genügend Feedback, um dein Dashboard anzuzeigen. Erkunde in der Zwischenzeit die Verhaltensweisen, die wir messen.',
      hint: 'Dein Dashboard wird freigeschaltet, sobald du mehr als 3 Umfragen beantwortet und mindestens 3 Bewertungen von Kolleginnen und Kollegen erhalten hast.',
      answeredLabel: 'Von dir beantwortete Umfragen',
      receivedLabel: 'Erhaltene Bewertungen',
    },
    error: {
      title: 'Dein Dashboard konnte nicht geladen werden',
      desc: 'Beim Abrufen deiner Daten ist ein Problem aufgetreten. Versuche es erneut; wenn es weiterhin auftritt, informiere den Support.',
      retry: 'Erneut versuchen',
      retrying: 'Wird erneut versucht…',
    },
    given: {
      loading: 'Verlauf wird geladen…',
      empty: 'Du hast noch keine Umfrage beantwortet.',
      loadError: 'Dein Verlauf beantworteter Umfragen konnte nicht geladen werden.',
      completed: 'Abgeschlossen',
      peopleCount_one: '{{count}} Person',
      peopleCount_other: '{{count}} Personen',
    },
    celebration: {
      default: 'Deine Art zu arbeiten hinterlässt Spuren bei den Menschen um dich herum.',
      learner: 'Deine Neugier und Lernbereitschaft inspirieren die Menschen, mit denen du arbeitest.',
      player_owner: 'Du übernimmst Verantwortung, ohne dass jemand fragt — das gibt dem Team den Takt vor.',
      psychological_safety: 'So wie du zuhörst, trauen sich andere zu sagen, was sie denken.',
      collaborate_effectively: 'Wenn du zusammenarbeitest, kommen alle schneller voran.',
      quality_of_work: 'Deine Sorgfalt hebt den Standard dessen, was das Team abliefert.',
      make_others_successful: 'Du sorgst dafür, dass andere glänzen, und das ganze Team merkt es.',
      explore_experiment: 'Deine Bereitschaft, Neues auszuprobieren, öffnet Wege, die niemand gesehen hatte.',
    },
    popup: {
      peersOpined: 'Kollegen haben bewertet',
      evaluationsCount: '{{count}} Bewertungen',
      subbehaviors: 'Teilverhalten',
      dailyHabits: 'Tägliche Gewohnheiten',
      monthlyHistory: 'Monatliche Entwicklung',
      distribution: 'Feedback-Verteilung',
      behaviorScale: 'Verhaltensskala',
      you: 'Sie',
    },
  },
  admin: {
    title: 'Verwaltung',
    menu: {
      general: 'General-Admin',
      pulso: 'Pulso',
      brillamos: 'Brillamos',
    },
    roleAdminGeneral: 'General-Admin',
    roleAdminPulso: 'Pulso-Admin',
    roleAdminOUPulso: 'Pulso OE-Admin',
    roleAdminBrillamos: 'Brillamos-Admin',
    roleAdminOUBrillamos: 'Brillamos OE-Admin',
    roleEmployee: 'Mitarbeiter',
    greetingMorning: 'Guten Morgen',
    greetingAfternoon: 'Guten Tag',
    greetingEvening: 'Guten Abend',
    surveys: 'Umfragen',
    templates: 'Vorlagen',
    analyticsTab: 'Analytik',
    rulesTab: 'Geschäftsregeln',
    users: 'Benutzer',
    notifications: 'Benachrichtigungen',
    surveysTitle: 'Umfragenverwaltung',
    searchSurvey: 'Umfrage suchen...',
    trash: 'Papierkorb',
    newSurvey: 'Neue Umfrage',
    fundamentalsTab: 'Grundwerte',
    customTab: 'Benutzerdefiniert',
    colName: 'Name',
    colTitle: 'Titel',
    colDescription: 'Beschreibung',
    colQuestions: 'Fragen',
    colStatus: 'Status',
    colAudience: 'Zielgruppe',
    sectionCrashed: "Dieser Bereich konnte nicht angezeigt werden. Bitte erneut versuchen oder einen anderen wählen.",
    colFrequency: 'Häufigkeit',
    freqDaily: 'Täglich',
    freqWorkdays: 'Werktage',
    freqWeekly: 'Wöchentlich · {{day}}',
    freqCustom: '{{count}} Tage/Woche',
    freqNone: '—',
    colFeedback: 'Rückmeldungen',
    colPeriod: 'Zeitraum',
    colActions: 'Aktionen',
    colCreatedBy: 'Erstellt von',
    creatorUnknown: 'Unbekannt',
    colEmail: 'E-Mail',
    colOU: 'OE',
    colUses: 'Nutzungen',
    statusActive: 'Aktiv',
    statusPaused: 'Pausiert',
    statusInactive: 'Inaktiv',
    statusPending: 'Ausstehend',
    anonymous: 'Anonym',
    duplicate: 'Duplizieren',
    exportExcelTip: 'Excel exportieren',
    templatesTitle: 'Umfragevorlagen',
    tipsTab: 'Tipps',
    actionsTab: 'Aktionen',
    catalogTab: 'Kataloge',
    createTemplate: 'Vorlage erstellen',
    typeFundamental: 'Grundwert',
    typeCustom: 'Benutzerdefiniert',
    placeholderTips: 'Tipps — Ratgebermodul für Mitarbeiter',
    tplSearchPlaceholder: 'Template suchen…',
    tplFilterAll: 'Alle Typen',
    tplNoResults: 'Keine Templates gefunden',
    tipsTitle: 'Feedback-Tipps',
    tipsSearchPlaceholder: 'Tipp suchen…',
    tipsAllFundamentals: 'Alle Grundwerte',
    tipsAllTypes: 'Alle Typen',
    tipTypeReconocer: 'Zum Anerkennen',
    tipTypeCrecer: 'Zum Wachsen',
    tipsNoResults: 'Keine Tipps gefunden',
    surveysNoResults: 'Keine Umfragen mit diesem Kriterium',
    surveysError: 'Fehler beim Laden der Umfragen. Bitte versuchen Sie es später erneut.',
    createTip: 'Tipp erstellen',
    actionsTitle: 'Wachstumsmaßnahmen',
    actionsSearchPlaceholder: 'Maßnahme suchen…',
    actionsNoResults: 'Keine Maßnahmen gefunden',
    createAction: 'Maßnahme erstellen',
    catalogTitle: 'Grundwerte-Katalog',
    catalogFundamentals: 'Grundwerte',
    catalogBehaviors: 'Verhaltensweisen',
    catalogAddFundamental: 'Grundwert hinzufügen',
    catalogAddBehavior: 'Daily Habit hinzufügen',
    catalogSearchFundamental: 'Grundwert suchen…',
    catalogSearchBehavior: 'Daily Habit suchen…',
    catalogNoBehaviors: 'Keine Daily Habits für diesen Grundwert',
    catalogSelectFundamental: 'Wählen Sie einen Grundwert aus der Liste',
    ousTab: 'OEs',
    ousTitle: 'Organisationseinheiten',
    ousSubtitle: 'Root-OEs des Tenants verwalten',
    ousSearchPlaceholder: 'OE suchen…',
    ousNoResults: 'Keine OE entspricht dem Kriterium',
    createOU: 'OE erstellen',
    editOU: 'OE bearbeiten',
    deleteOU: 'OE löschen',
    deleteOUConfirm: 'OE "{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    ouDescription: 'Beschreibung',
    ouAdminUser: 'OE-Admin (AAD User ID)',
    ouType: 'Typ',
    ouGdpr: 'DSGVO',
    ouAzureGroupId: 'Azure AD-Gruppen-ID',
    ouAzureGroupIdHint: 'Verknüpfen Sie diese OE mit ihrer echten Azure AD-Gruppe für die Hierarchieansicht. Leer lassen, wenn noch nicht bereitgestellt.',
    ouAzureGroupIdSelectPlaceholder: '— Azure AD-Stammgruppe auswählen —',
    ouAzureGroupIdLoading: 'Azure AD-Gruppen werden geladen…',
    ouAzureGroupIdRootsError: 'Die Liste der Azure AD-Gruppen konnte nicht geladen werden. Sie können die ID manuell eingeben.',
    ouAzureGroupIdCurrentUnknown: 'Aktuell verknüpfte Gruppe (nicht in der Liste)',
    ouAzureGroupIdManualToggle: 'ID manuell eingeben',
    ouAzureGroupIdListToggle: 'Aus der Liste wählen',
    ouActivate: 'OE aktivieren',
    ouDeactivate: 'OE deaktivieren',
    ouActivateCascadeTitle: 'OE und untergeordnete Einheiten aktivieren',
    ouActivateCascadeConfirm: 'Beim Aktivieren von „{{name}}“ werden auch alle untergeordneten Einheiten aktiviert (betroffene Einheiten: {{units}}). Sie können sie danach einzeln deaktivieren.',
    ouDeactivateCascadeTitle: 'OE und untergeordnete Einheiten deaktivieren',
    ouDeactivateCascadeConfirm: 'Beim Deaktivieren von „{{name}}“ werden auch alle untergeordneten Einheiten deaktiviert (betroffene Einheiten: {{units}}).',
    ouActiveSaveError: 'Die Statusänderung der OE konnte nicht gespeichert werden. Bitte erneut versuchen.',
    ouExpand: 'Erweitern',
    ouLockedHint: "Ihre Organisationseinheit: kann nicht aus dem Geltungsbereich entfernt werden.",
    ouCollapse: 'Einklappen',
    ouSelectPlaceholder: 'OU auswählen…',
    ouSearchPlaceholder: 'OU suchen…',
    ouSearchNoResults: 'Keine Ergebnisse.',
    ouInactiveHint: 'Inaktive OU: kann nicht als neuer Geltungsbereich gewählt werden.',
    ouSelectAllInLevel: 'Alle auswählen',
    ouBackToLevels: 'Zurück zur vorherigen Ebene',
    ouErrorName: 'Der OE-Name ist erforderlich',
    ouTimezone: 'Zeitzone',
    ouTimezoneSelect: 'Zeitzone auswählen',
    ouErrorTimezone: 'Zeitzone ist erforderlich',
    colFundamental: 'Grundwert',
    colCondition: 'Bedingung',
    placeholderActions: 'Aktionen — Aktionspläne nach Umfragen',
    placeholderCatalog: 'Grundwerte-Katalog — Bibliothek bewertbarer Verhaltensweisen',
    placeholderAnalytics: 'Einheitliches Analyse-Dashboard — Führungsansicht für vollständige Details',
    activeUsersLabel: 'Aktive Mitarbeiter',
    avgCulturalScore: 'Durchschnittlicher Kulturscore',
    participationRateLabel: 'Teilnahmequote',
    omissionRateLabel: 'Auslassungsquote',
    thisMonth: 'diesen Monat',
    rulesTitle: 'Geschäftsregeln',
    restoreDefaults: 'Standards wiederherstellen',
    restoreDefaultsTitle: 'Standardkonfiguration wiederherstellen',
    restoreDefaultsDesc: 'Alle Werte der Geschäftsregeln werden auf ihre ursprüngliche Konfiguration zurückgesetzt. Diese Aktion kann nicht rückgängig gemacht werden.',
    restoreDefaultsConfirm: 'Ja, wiederherstellen',
    rn001Title: 'Besprechungskriterien',
    rn001Subtitle: 'Legt die Besprechungsdauer fest, die eine Umfrage auslöst',
    rn002Title: 'Ausschlussregeln',
    rn002Subtitle: 'Szenarien, bei denen KEINE Umfragen ausgelöst werden',
    rn004Title: 'Benutzerlimits',
    rn004Subtitle: 'Steuert die Anzahl der Umfragen, die jede Person erhält',
    rn005Title: 'Tägliches Umfragenlimit',
    rn005Subtitle: 'Maximale Anzahl von Umfragen, die ein Benutzer pro Tag erhalten kann',
    fieldMinSessionDuration: 'Mindestdauer der Sitzung',
    fieldMaxSessionDuration: 'Maximaldauer der Sitzung',
    fieldMinParticipants: 'Mindestteilnehmer',
    fieldMaxParticipants: 'Maximalteilnehmer',
    fieldExclRecurring: 'Wiederkehrende Besprechungen ausschließen',
    fieldExclRecurringSub: 'Nicht auf wöchentliche Meetings, Dailies usw. anwenden',
    fieldExclWorkHours: 'Außerhalb der Arbeitszeiten ausschließen',
    fieldExclWorkHoursSub: 'Nur innerhalb der je OE konfigurierten Zeiten anwenden',
    fieldMaxSurveysWeek: 'Maximale Umfragen pro Woche',
    fieldMaxParticipantsPerSurvey: 'Maximale zu bewertende Teilnehmer pro Umfrage',
    fieldMinInterval: 'Mindestintervall zwischen Umfragen',
    fieldMaxSurveysDay: 'Maximale Umfragen pro Tag pro Benutzer',
    rn005Info: 'Wenn ein Benutzer bereits die maximale Anzahl an Umfragen für den Tag erhalten hat, werden die folgenden auf den nächsten Werktag verschoben und dabei die konfigurierte Prioritätsreihenfolge eingehalten.',
    suffixMinutes: 'Minuten',
    suffixUsers: 'Benutzer',
    suffixSurveysWeek: 'Umfragen/Woche',
    suffixPersons: 'Personen',
    suffixHours: 'Stunden',
    suffixSurveysDay: 'Umfragen / Tag',
    customizableByOU: 'Anpassbar pro OE',
    cancelChanges: 'Änderungen abbrechen',
    saveConfig: 'Konfiguration speichern',
    rulesConfig: 'Konfiguration',
    rulesStatus: 'Status',
    rulesCustom: 'Benutzerdefiniert',
    rulesSave: 'Speichern',
    rulesCancel: 'Abbrechen',
    rulesSchedule: 'Zeitplan',
    rulesInheritsGlobal: '↑ Erbt global',
    rulesInherited: 'Geerbt',
    rulesGlobal: 'Global',
    rulesPersonalize: 'Anpassen',
    tplCatAll: 'Alle',
    tplCatGeneral: 'Allgemein',
    tplCatCustom: 'Benutzerdefiniert',
    usersTitle: 'Benutzerverwaltung',
    searchUser: 'Benutzer suchen...',
    newUser: 'Neuer Benutzer',
    notificationsTitle: 'Benachrichtigungseinstellungen',
    notifOmitirTitle: 'Übersprungen-Benachrichtigung',
    notifyAfter: 'Benachrichtigen nach',
    consecutiveOmissions: 'aufeinanderfolgenden Überspringungen',
    notifyTo: 'Benachrichtigen:',
    notifyUser: 'Benutzer',
    notifyDirectManager: 'Direkter Vorgesetzter',
    notifyAdminOU: 'OE-Administrator',
    messageForUser: 'Nachricht für den Benutzer:',
    availableVarsOmitir: 'Verfügbare Variablen: {nombre}, {count}, {fecha}, {manager}',
    europaOmissionsTitle: 'Europa-Auslassungen (BU)',
    manualOnlyGDPR: 'Nur manuell — DSGVO',
    gdprWarning: 'Aufgrund gesetzlicher Vorschriften (DSGVO) werden Auslassungs-E-Mails für Europa niemals automatisch gesendet. Der Administrator muss sie manuell verfassen, überprüfen und senden.',
    emailTemplateEmployee: 'E-Mail-Vorlage — Europa-Mitarbeiter:',
    reviewBeforeSending: 'Vor jedem Versand überprüfen und anpassen.',
    generalNotificationsTitle: 'Allgemeine Benachrichtigungen',
    notifMessageLabel: 'Benachrichtigungsnachricht:',
    notifMessagePlaceholder: 'Schreiben Sie die Nachricht, die Sie den Mitarbeitern senden möchten...',
    notifAudienceLabel: 'Zielgruppe:',
    notifAudienceGlobal: 'Global (ohne Europa)',
    sendNotification: 'Benachrichtigung senden',
    availableVarsGeneral: 'Verfügbare Variablen: {nombre}, {ou}, {fecha}',
    saveChanges: 'Änderungen speichern',
    saveTemplates: 'Vorlagen speichern',
    analyticsComingSoon: 'Analytics-Dashboard — in Entwicklung. Siehe Executive-Ansicht für vollständige Details.',
    colType: 'Typ',
    tplCategory: 'Kategorie',
    tplQuestions: 'Fragen',
    tplUse: 'Verwenden',
    tplDeleteTitle: 'Vorlage löschen',
    tplDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    tipDeleteTitle: 'Tipp löschen',
    tipDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    tipEditTitle: 'Tipp bearbeiten',
    tipAddTitle: 'Tipp hinzufügen',
    tipFormFundamental: 'Fundamental',
    tipFormSelectFundamental: 'Wählen Sie ein Fundamental…',
    tipFormDailyHabit: 'Verknüpfte Daily Habit',
    tipFormSelectDailyHabit: 'Wählen Sie eine Daily Habit…',
    tipFormOperator: 'Operator',
    tipFormThreshold: 'Schwellenwert %',
    tipFormMax: 'Max %',
    tipFormType: 'Tipp-Typ',
    tipFormName: 'Tipp-Name',
    tipFormNamePlaceholder: 'Z.B. Herausragendes Lernen',
    tipFormText: 'Tipp-Text',
    tipFormTextPlaceholder: 'Nachricht, die der Mitarbeiter sehen wird…',
    tipFormActivationRule: 'Ergebnisbedingung',
    tipFormActive: 'Aktiv',
    tipFormPreview: 'Vorschau',
    tipRangeMin: 'Mindestgrenze',
    tipRangeMax: 'Höchstgrenze',
    tipHintCondition: 'Durchschnittlicher Score des Fundamentals (0–100). Bsp: 0 bis 40 aktiviert den Tipp bei niedrigen Ergebnissen.',
    tipHintBehavior: 'Spezifisches Verhalten, auf das dieser Tipp zutrifft.',
    tipFieldObserved: 'Beobachteter Text',
    tipTagGreen: 'helle grüne Box',
    tipTagDark: 'dunkle Box',
    tipTagBlue: 'Nächste Stufe-Box',
    tipHintObserved: 'Was Kollegen am häufigsten beobachten. Erscheint kursiv im Leistungspanel.',
    tipFieldGrowthSuggestion: 'Wachstumsempfehlung',
    tipHintGrowthSuggestion: 'Umsetzbare Empfehlung, die neben der Anerkennung erscheint.',
    tipFieldLevelName: 'Stufenname',
    tipLevelNamePlaceholder: 'Bsp. Nötiger Impuls, Im Aufbau…',
    tipCrecerPairedPlaceholder: 'Bsp. Erwähnen Sie den Verbraucher: Fragen Sie bei Ihrer nächsten Entscheidung…',
    tipTranslations: 'Übersetzungen',
    tipAddLang: '+ Hinzufügen:',
    tipPreviewContext: 'So erscheint es im Dashboard des Mitarbeiters:',
    tipSave: 'Tipp speichern',
    tipSaveError: 'Zum Speichern folgende Felder ausfüllen:',
    colContent: 'Inhalt',
    colActive: 'Aktiv',
    opGte: 'größer oder gleich',
    opLte: 'kleiner oder gleich',
    opGt: 'größer als',
    opLt: 'kleiner als',
    opBetween: 'Zwischen (Bereich)',
    actionEditTitle: 'Aktion bearbeiten',
    actionNewTitle: 'Neue Aktion',
    actionFormTitle: 'Aktionstitel',
    actionFormTitlePlaceholder: 'Z.B. Schlagen Sie eine konkrete Aktion vor',
    actionFormDescription: 'Vollständige Beschreibung',
    actionFormDescPlaceholder: 'Beschreibung der Aktion…',
    actionActivationRule: 'Aktivierungsregel',
    actionActivationRuleHint: 'Durchschnittlicher Fundamental-Score (1–4). Definiert den Bereich, der diese Aktion auslöst.',
    actionRuleMin: 'Mindestschwelle',
    actionRuleMax: 'Höchstschwelle',
    actionRangeLabel: 'Bereich',
    actionNextLevelText: '"Nächste Stufe"-Text',
    actionNextLevelHint: 'Wird im blauen Kasten der Karte angezeigt.',
    actionNextLevelPlaceholder: 'Z.B. Um die nächste Stufe zu erreichen, konzentriere dich auf…',
    actionPreview: 'Vorschau',
    actionPreviewEmpty: 'Fülle das Formular aus, um die Vorschau zu sehen',
    actionTranslations: 'Übersetzungen',
    actionTransComplete: 'Übersetzung vollständig',
    actionTransMissing: 'Übersetzung unvollständig',
    actionPreviewContext: 'So wird es im Dashboard des Mitarbeiters angezeigt:',
    actionFormDescHint: 'Wird beim Öffnen der Aktion angezeigt.',
    actionSave: 'Aktion speichern',
    actionSaveError: 'Zum Speichern, bitte folgende Felder ausfüllen:',
    actionDeleteTitle: 'Aktion löschen',
    actionDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    fundEditTitle: 'Fundamental bearbeiten',
    fundNewTitle: 'Neues Fundamental',
    fundFormFullName: 'Vollständiger Name',
    fundFormFullNamePlaceholder: 'Z.B. Mindset & Behavior - Learner',
    fundFormShortName: 'Kurzname',
    fundFormShortNamePlaceholder: 'Z.B. Learner',
    fundFormDescription: 'Beschreibung',
    fundFormDescriptionPlaceholder: 'Kurze Beschreibung dieses Fundamentals...',
    fundFormIcon: 'Symbol',
    fundFormColor: 'Farbe',
    fundFormUrl: 'Referenz-URL',
    fundFormMicrositeUrl: 'URL der Microsite',
    fundFormUrlPlaceholder: 'https://...',
    fundFormLanguage: 'Sprache',
    fundFormAllLangsRequired: 'Füllen Sie den vollständigen Namen, Kurznamen und die Beschreibung in allen 7 Sprachen aus, um zu speichern.',
    behEditTitle: 'Daily Habit bearbeiten',
    behNewTitle: 'Neues Daily Habit',
    behFormName: 'Daily Habit Name',
    behFormNamePlaceholder: 'Z.B. Humility & Openness',
    behFormAllLangsRequired: 'Füllen Sie den Namen in allen 7 Sprachen aus, um zu speichern.',
    behFormFundamental: 'Verknüpftes Fundamental',
    behFormIntro: 'Einleitung / Bewertungskontext',
    behFormIntroPlaceholder: 'Z.B. In diesem Meeting hat diese Person…',
    behFormRoles: 'Anwendbare Rollen',
    behFormRolesHint: 'Für wen gilt diese Daily Habit?',
    fundDeleteTitle: 'Fundamental löschen',
    fundDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    behDeleteTitle: 'Daily Habit löschen',
    behDeleteDesc: '"{{name}}" löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    imageUploadSelect: 'Bild hochladen',
    imageUploadChange: 'Bild ändern',
    imageUploadInvalidFormat: 'Nicht unterstütztes Format. Verwende PNG, JPG, WEBP oder SVG.',
    imageUploadTooLarge: 'Die Datei überschreitet die maximal zulässige Größe (2 MB).',
    catalogSaveError: 'Die Änderungen am Katalog konnten nicht gespeichert werden. Bitte erneut versuchen.',
    catalogImageUploadError: 'Das Bild konnte nicht hochgeladen werden. Bitte erneut versuchen.',
    fundFormImage: 'Bild',
    attNewTitle: 'Neue Haltung und Verhalten',
    attEditTitle: 'Haltung und Verhalten bearbeiten',
    attFormName: 'Name der Haltung und Verhalten',
    attFormNamePlaceholder: 'Z. B. Aktive Zusammenarbeit',
    attFormDescription: 'Beschreibung der Haltung und des Verhaltens',
    attFormDescriptionPlaceholder: 'Kurze Beschreibung dieser Haltung und dieses Verhaltens...',
    attFormAllLangsRequired: 'Fülle den Namen in allen 7 Sprachen aus, um zu speichern.',
    // Botón "Traducir a los demás idiomas" de los modales del catálogo de fundamentales
    catalogTranslateBtn: 'In die anderen Sprachen übersetzen',
    catalogTranslating: 'Übersetzung läuft…',
    catalogTranslateHint: 'Geben Sie den Text in mindestens einer Sprache ein, um übersetzen zu können.',
    catalogTranslateErrorRetry: 'Die Übersetzung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    catalogTranslateErrorWait: 'Der Übersetzungsdienst ist derzeit nicht verfügbar. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
    attFormImage: 'Bild',
    attDeleteTitle: 'Haltung und Verhalten löschen',
    attDeleteDesc: '"{{name}}" löschen? Die zugehörigen Daily Habits werden ebenfalls deaktiviert.',
    catalogAttitudesLabel: 'Haltungen und Verhalten',
    catalogSelectAttitude: 'Wähle eine Haltung und Verhalten aus der Liste',
    catalogBackToFundamentals: 'Zurück zu Fundamentals',
    catalogBackToAttitudes: 'Zurück zu Haltungen und Verhalten',
    catalogGroupWithAttitudes: 'Unter Haltungen und Verhalten gruppieren',
    catalogNoFundamentals: 'Keine Fundamentals',
    madurezEditTitle: 'Kulturelle Reifestufen bearbeiten',
    madurezFrameworkTitle: 'Kulturelle Reife — Stufenrahmen',
    nivelesAdopcionTitle: 'Adoptionsstufen eines Daily Habits — Stufenrahmen',
    nivelesAdopcionEditTitle: 'Adoptionsstufen eines Daily Habits bearbeiten',
    madurezLabelPlaceholder: 'Bezeichnung',
    audienceGlobal: 'Global (ohne Europa)',
    audienceMexico: 'Mexiko',
    audienceLATAM: 'LATAM',
    audienceUSA: 'USA',
    audienceFOSE: 'FOSE',
    rn000Title: 'App pro OE deaktivieren',
    rn000Subtitle: 'Schaltet Sigma Pulse für eine oder mehrere Organisationseinheiten vollständig ab.',
    rn000Warning: 'Beim Deaktivieren einer OE erhalten alle Mitarbeiter sofort keine Umfragen mehr. Historische Daten werden aufbewahrt.',
    rn003Title: 'Arbeitszeiten pro OE',
    rn003Subtitle: 'Zeiten, in denen Umfragen angewendet werden (Ortszeit)',
    rn003GlobalDefault: 'Globale Standardzeiten',
    rn003GlobalNote: 'Gilt für alle OEs ohne eigene Zeiteinstellung.',
    rn003TimeConnector: 'bis',
    ouActive: 'Aktiv',
    ouDisabled: 'Deaktiviert',
    rn002KwLabel: 'Nur ausschließen, wenn der Name enthält:',
    rn002KwHint: '(leer = alle wiederkehrenden)',
    rn002KwPlaceholder: 'Stichwort hinzufügen...',
    usersAdminTitle: 'Administratorenverwaltung',
    addAdmin: 'Administrator hinzufügen',
    editAdmin: 'Administrator bearbeiten',
    newAdmin: 'Neuer Administrator',
    adminEmail: 'E-Mail-Adresse',
    adminUser: 'Benutzer',
    userSearchPlaceholder: 'Nach Name oder E-Mail suchen…',
    userSearchNoResults: 'Keine Benutzer gefunden',
    userSearchError: 'Fehler bei der Benutzersuche',
    adminRole: 'Rolle',
    adminRolePlaceholder: 'Rolle auswählen...',
    adminOU: 'Organisationseinheit (OE)',
    adminOUPlaceholder: 'OE auswählen...',
    adminOUAll: 'Alle (vollständiger OE-Zugriff)',
    adminBU: 'Geschäftseinheit (BU) — optional',
    adminBUPlaceholder: 'Gesamte OE (keine Einschränkung)',
    adminBUHint: 'Ohne BU-Auswahl verwaltet der Admin die gesamte OE.',
    colUser: 'Benutzer',
    colAlcance: 'Geltungsbereich',
    colPermisos: 'Berechtigungen',
    colEstado: 'Status',
    accountActive: 'Konto aktiv (Zugang zur Plattform)',
    accountActiveHint: 'Das ist das Konto der Person, nicht ihre Administratorrolle. Ausgeschaltet kann sie sich nicht anmelden.',
    deactivateAccountTitle: 'Konto deaktivieren',
    deactivateAccountMsg: '{{name}} kann sich nicht mehr bei der Plattform anmelden. Die Rolle bleibt erhalten: Das Konto wird deaktiviert. Fortfahren?',
    deactivateAccountConfirm: 'Ja, Konto deaktivieren',
    permGlobalTitle: 'OE/BU-Admins können Umfragen erstellen',
    permGlobalDesc: 'Wenn aktiv, können alle OE/BU-Admins Umfragen erstellen und senden.',
    permEnabled: 'Aktiviert',
    permDisabled: 'Deaktiviert',
    permCreateSurveys: 'Umfragen erstellen',
    permViewAnalytics: 'Analytics anzeigen',
    permManageUsers: 'Benutzer verwalten',
    permApproveSurveys: 'Umfragen genehmigen',
    permCatalogFund: 'Katalog Fundamentals',
    permCatalogOus: 'Katalog OUs',
    // 2026-08-08 — Neuordnung des Administrationsmenüs
    administratorsTab: 'Administratorverwaltung',
    catalogFundTab: 'Katalog Fundamentals',
    catalogOusTab: 'Katalog OUs',
    rolesPulsoTab: 'Rollen und Berechtigungen konfigurieren',
    rolesPulsoTitle: 'Rollen und Berechtigungen konfigurieren',
    rolesPulsoAllScopes: 'Alle',
    rolesPulsoAlreadyNote: 'Diese Person ist bereits Pulso-Administrator:in — bearbeiten Sie ihre Daten unten.',
    rolesPulsoCannotEditGlobal: 'Diese Person hat bereits die Rolle Admin Allgemein. Diese Rolle wird nicht von hier aus verwaltet.',
    administratorsTitle: 'Administratorverwaltung',
    administratorsDesc: 'Globale Systemadministratoren hinzufügen oder entfernen.',
    addGlobalAdmin: 'Administrator hinzufügen',
    newGlobalAdmin: 'Neuer globaler Administrator',
    adminGlobalRemoveTitle: 'Globalen Administrator entfernen',
    adminGlobalRemoveDesc: '"{{name}}" als globalen Administrator entfernen? Das Konto bleibt als Standard-Mitarbeiter bestehen.',
    userDeleteTitle: 'Administrator entfernen',
    userDeleteDesc: '"{{name}}" als Administrator entfernen? Das Konto bleibt als Standardmitarbeiter aktiv, ohne Administratorrechte.',
    userCreated: 'Benutzer erfolgreich erstellt.',
    userSaveError: 'Die Änderungen konnten nicht gespeichert werden. Bitte erneut versuchen.',
    userSaveForbidden: 'Sie haben keine Berechtigung, diesen Administrator zu ändern. Nur ein General-Admin kann das.',
    userCreateErrorNotInAd: 'Der Benutzer konnte nicht erstellt werden: Die E-Mail existiert nicht in Azure AD.',
    userDeleteError: 'Die Administratorrolle konnte nicht entfernt werden. Bitte erneut versuchen.',
    noUsersFound: 'Keine Ergebnisse',
    adminCount: 'Administratoren',
    filterEmailPlaceholder: 'Nach E-Mail suchen...',
    filterRoleLabel: 'Nach Rolle filtern',
    filterRoleAll: 'Alle Rollen',
    filterClear: 'Filter zurücksetzen',
    rolesMultiHint: 'Sie können mehrere Rollen auswählen, indem Sie die Strg-Taste (Cmd auf dem Mac) gedrückt halten.',
    modulesTitle: 'Module',
    modulesHint: 'Legt fest, auf welche Produktmodule zugegriffen werden kann, unabhängig von der zugewiesenen Rolle.',
    modulePulso: 'Pulso',
    moduleBrillamos: 'Anerkennung',
    permAllGranted: 'Alle gewährt',
    userNotManageable: 'Sie können diesen Benutzer nicht verwalten',
    messageForManager: 'Nachricht für den Manager:',
    emailTemplateManager: 'E-Mail-Vorlage — Europa-Manager:',
    notifOUPersonalization: 'Personalisierung pro OE',
    addOUPersonalization: 'Personalisierung hinzufügen',
    europaNoAutoSend: 'Diese E-Mails werden nicht automatisch gesendet. Sie müssen manuell gesendet werden.',
    europaActivateTitle: 'Europa-Benachrichtigungen aktivieren?',
    europaActivateDesc: 'Benachrichtigungen über Auslassungen für Europa unterliegen strengen DSGVO-Vorschriften. Durch die Aktivierung dieses Abschnitts bestätigen Sie, dass Sie die Genehmigung des Datenschutzbeauftragten der OE Europa haben und dass E-Mails manuell mit vorheriger Prüfung gesendet werden.',
    europaActivateConfirm: 'Ja, verantwortungsvoll aktivieren',
    includeEuropa: 'Europa (BU) einbeziehen',
    includeEuropaHint: 'erfordert DSGVO-Prüfung vor dem Senden',
    europaSectionDisabled: 'Abschnitt deaktiviert — Schalter aktivieren zum Konfigurieren',
    ouPersonalizedSingular: 'personalisierte OU',
    ouPersonalizedPlural: 'personalisierte OUs',
    notifCustomUserMsgPlaceholder: 'Benutzerdefinierte Nachricht für den Benutzer…',
    notifCustomMgrMsgPlaceholder: 'Benutzerdefinierte Nachricht für den Manager…',
    kwRemove: 'Entfernen',
    kwAdd: 'Hinzufügen',
    permissions: 'Berechtigungen',
    rules: 'Geschäftsregeln',
    catalog: 'Katalog',
    createUser: 'Benutzer erstellen',
    editUser: 'Benutzer bearbeiten',
    deleteUser: 'Benutzer löschen',
    roles: 'Rolle',
    organizationalUnit: 'Organisationseinheit',
    minDuration: 'Mindestdauer (min)',
    maxDuration: 'Maximaldauer (min)',
    minParticipants: 'Mindestteilnehmer',
    maxPerDay: 'Max. Bewertungen pro Tag',
    maxPerWeek: 'Max. Bewertungen pro Woche',
    omissionThreshold: 'Auslassungsschwelle',
    columns: 'Spalten',
    colPickerTitle: 'Sichtbare Spalten',
    colPickerReset: 'Zurücksetzen',
    pagerRowsPerPage: 'Zeilen pro Seite',
    pagerOf: 'von',
    confirmMoveToTrash: 'In den Papierkorb verschieben?',
    confirmMoveToTrashMsg: 'Die Umfrage wird in den Papierkorb verschoben und nach 30 Tagen endgültig gelöscht. Sie können sie vorher wiederherstellen.',
    confirmMoveBtn: 'In den Papierkorb',
    confirmDeleteForeverTitle: 'Endgültig löschen?',
    confirmDeleteForeverMsg: 'Diese Aktion ist unumkehrbar. Die Umfrage und alle ihre Daten werden dauerhaft gelöscht.',
    confirmDeleteForeverBtn: 'Endgültig löschen',
    trashTitle: 'Papierkorb',
    trashSubtitle: 'Umfragen werden nach 30 Tagen endgültig gelöscht',
    trashEmpty: 'Der Papierkorb ist leer',
    trashRestore: 'Wiederherstellen',
    trashDaysLeft: 'Tage übrig',
    colSurvey: 'Umfrage',
    trashResponses: 'Antw.',
    trashTimeLeft: 'Verbleibende Zeit',
    trashDeletedBy: 'Gelöscht von',
    trashDeletedAt: 'Löschdatum',
    trashDays: 'Tage',
    trashExpiresTODAY: 'Läuft heute ab',
    filterAll: 'Alle',
    filterSearchName: 'Name suchen…',
    filterSearchCreator: 'Ersteller suchen…',
    filterFrom: 'Von',
    filterTo: 'Bis',
    filterClearDates: 'Daten löschen',
    pauseSurvey: 'Pausieren',
    activateSurvey: 'Aktivieren',
    builderNewTitle: 'Neue Umfrage',
    builderEditTitle: 'Umfrage bearbeiten',
    builderNewTemplateTitle: 'Neue Vorlage',
    builderEditTemplateTitle: 'Vorlage bearbeiten',
    builderBackToSurveys: 'Zurück zu Umfragen',
    builderSaveDraft: 'Entwurf speichern',
    builderPublish: 'Umfrage veröffentlichen',
    builderStep1: 'Grundinformationen',
    builderStep2: 'Zielgruppe und Häufigkeit',
    builderStep3: 'Fragen',
    builderStep4: 'Überprüfung',
    builderPreview: 'Vorschau',
    builderName: 'Name der Umfrage',
    builderNamePlaceholder: 'Bsp: Post-Meeting-Bewertung Q2',
    builderDescription: 'Beschreibung',
    builderDescriptionPlaceholder: 'Beschreiben Sie den Zweck dieser Umfrage…',
    builderApproach: 'Ansatz',
    builderApproachIndividual: 'Individuell',
    builderApproachCollective: 'Kollektiv',
    builderAnonymous: 'Anonyme Bewertung',
    builderAnonymousSub: 'Die Beurteilten wissen nicht, wer sie bewertet hat',
    dayMon: 'Montag', dayTue: 'Dienstag', dayWed: 'Mittwoch', dayThu: 'Donnerstag',
    dayFri: 'Freitag', daySat: 'Samstag', daySun: 'Sonntag',
    dayMonShort: 'Mo', dayTueShort: 'Di', dayWedShort: 'Mi', dayThuShort: 'Do',
    dayFriShort: 'Fr', daySatShort: 'Sa', daySunShort: 'So',
    dayLetterMon: 'M', dayLetterTue: 'D', dayLetterWed: 'M', dayLetterThu: 'D',
    dayLetterFri: 'F', dayLetterSat: 'S', dayLetterSun: 'S',
    activeDaysAll: 'Die Umfrage ist die ganze Woche aktiv',
    activeDaysPrefix: 'Die Umfrage ist aktiv an:',
    activeDaysNone: 'Kein Tag ausgewählt',
    workdays: 'Werktage',
    builderExitTitle: 'Editor verlassen?',
    builderExitDesc: 'Nicht gespeicherte Änderungen gehen verloren, wenn Sie jetzt verlassen.',
    builderExitCancel: 'Weiter bearbeiten',
    builderExitConfirm: 'Ja, verlassen',
    builderValidationTitle: 'Pflichtfelder',
    builderValidationDesc: 'Bitte füllen Sie die folgenden Felder aus, bevor Sie fortfahren:',
    builderValidationClose: 'Verstanden',
    builderValidationName: 'Interner Bezeichner',
    builderValidationSurveyType: 'Umfragetyp',
    builderValidationStartDate: 'Startdatum',
    builderValidationEndDate: 'Enddatum',
    builderValidationDateRange: 'Das Enddatum darf nicht vor dem Startdatum liegen',
    builderValidationActiveDays: 'Mindestens ein aktiver Tag',
    builderValidationStartDatePast: 'Das Startdatum liegt bereits in der Vergangenheit; die Umfrage würde nie veröffentlicht',
    builderValidationEndDatePast: 'Das Enddatum liegt bereits in der Vergangenheit; die Umfrage würde nie veröffentlicht',
    builderValidationMeetingId: 'Meeting-ID eingeben',
    builderValidationPeople: 'Mindestens eine Person auswählen',
    builderValidationOU: 'Mindestens eine OE auswählen',
    builderValidationNoQuestions: 'Sie müssen mindestens eine Frage hinzufügen, um fortzufahren. Umfragen können nicht ohne Fragen erstellt werden.',
    builderValidationMinParticipants: 'Die Mindestanzahl an Teilnehmern muss mindestens 1 betragen',
    builderValidationMaxParticipants: 'Die Höchstanzahl an Teilnehmern muss mindestens 1 betragen',
    builderValidationParticipantsRange: 'Die Mindestanzahl darf nicht größer als die Höchstanzahl sein',
    builderValidationTranslations: 'Unvollständige Übersetzungen',
    // Builder new keys
    builderCloseEditor: 'Editor schließen',
    builderPrevious: 'Zurück',
    builderNext: 'Weiter',
    builderSaveTemplate: 'Als Vorlage speichern',
    builderInternalId: 'Interner Bezeichner',
    builderInternalIdHint: 'Nur für Administratoren sichtbar — Mitarbeiter sehen diesen Namen beim Ausfüllen nicht',
    builderSurveyTypeStar: 'Umfragetyp',
    builderTypeGeneral: 'Allgemein',
    builderTypeGeneralDesc: 'Geregelt durch Geschäftsregeln. Wird automatisch nach Meetings ausgelöst.',
    builderTypePersonalized: 'Personalisiert',
    builderTypePersonalizedDesc: 'Verknüpft mit einer bestimmten Teams-Sitzung über Meeting-ID.',
    builderPeriod: 'Umfragezeitraum',
    builderStartLabel: 'Beginn',
    builderEndLabel: 'Ende',
    builderPeriodHint: 'Die Umfrage wird am Startdatum aktiviert und automatisch am Ende deaktiviert',
    builderActiveDaysLabel: 'Aktivierungstage',
    builderActiveDaysLockedHint: 'Der Tag wird automatisch festgelegt, da der Datumsbereich nur einen Tag umfasst',
    builderCustomTag: 'Benutzerdefiniert',
    builderAudienceSectionTitle: 'Zielgruppe',
    builderWhoApplies: 'Für wen gilt diese Umfrage?',
    builderSelectOneOrMoreOUs: 'Eine oder mehrere OE auswählen',
    builderGlobal: 'Global',
    builderGlobalDesc: 'Alle OE und BU',
    builderExcludesEurope: 'ohne Europa',
    builderGlobalAdminOUAccess: 'Globaler Administrator — Sie haben Zugriff auf alle OEs im System.',
    builderLegalRegulation: 'Gesetzliche Vorschriften — immer ein separates Feld',
    builderEurope: 'Europa (BU)',
    builderGDPRTag: 'DSGVO — Gesetzliche Vorschriften',
    builderEuropeExcludedNote: 'Europa ist aus rechtlichen Gründen nie in globalen oder Multi-OE-Kampagnen enthalten.',
    builderEuropaAuthNote: 'Denken Sie daran, die Genehmigung der OE Europa einzuholen, bevor Sie Umfragen an diese Region senden.',
    builderAudienceCustomTitle: 'Empfänger',
    builderAudienceCustomSubtitle: 'Definieren Sie, wer diese personalisierte Umfrage erhalten soll.',
    builderRecipientsLabel: 'Empfänger',
    builderByMeetingId: 'Per Meeting-ID',
    builderByPeople: 'Bestimmte Personen',
    builderByOU: 'Per Organigramm (OE)',
    audienceTypeMeeting: 'Meeting',
    audienceTypePeople: 'Personen',
    audienceTypeOU: 'OE',
    builderMeetingIdHint: 'Gilt für alle Teilnehmer dieser Teams-Sitzung',
    builderSelectPeople: 'Personen aus der Liste auswählen',
    builderAllOUs: 'Alle OE',
    builderAllAvailableAdded: 'Alle verfügbaren Personen wurden bereits hinzugefügt',
    builderSearchPeoplePlaceholder: 'Person nach Namen suchen…',
    builderLoadingPeople: 'Personen werden geladen…',
    builderErrorLoadingPeople: 'Die Personenliste konnte nicht geladen werden. Erneut versuchen.',
    builderPersonSelected: 'Person ausgewählt',
    builderPeopleSelected: 'Personen ausgewählt',
    builderSelectOU: 'OE auswählen...',
    builderSelectOUForTeam: 'Wählen Sie eine OE aus, um deren Mitarbeiter anzuzeigen',
    builderQuestionsTitle: 'Fragen',
    builderEuropaQuestionsNote: 'Europa-Modus: freie Umfrage, nicht mit Grundwerten verknüpft. Nur Fragen zur Besprechung.',
    builderQuestionsApplyToAll: 'Jede Frage gilt für jeden Besprechungsteilnehmer.',
    builderFilterAll: 'Alle',
    builderNoQuestions: 'Noch keine Fragen',
    builderNoQuestionsHint: 'Klicken Sie auf "+ Frage hinzufügen", um zu beginnen',
    builderNoQuestionsOfType: 'Keine Fragen dieses Typs',
    builderAddQuestion: '+ Frage hinzufügen',
    builderQuestionLabel: 'Frage',
    builderDeleteQuestion: 'Löschen',
    builderApproachLabel: 'Ansatz',
    builderIndividualSub: 'Bewertet jeden Teilnehmer',
    builderCollectiveSub: 'Für die Sitzung insgesamt',
    builderPresentationMode: 'Darstellungsmodus',
    builderMatrix: 'Allgemeine Matrix',
    builderMatrixSub: 'Frage zur Besprechung oder zum allgemeinen Thema',
    builderIndividualCard: 'Individuell',
    builderIndividualCardSub: 'Eine Karte pro Person',
    builderTypeLabel: 'Typ',
    builderFundamentalLabel: 'Grundwert',
    builderSelectFundamental: 'Grundwert auswählen...',
    builderDailyHabitLabel: 'Tägliche Gewohnheit',
    builderSelectDailyHabit: 'Tägliche Gewohnheit auswählen...',
    builderQuestionText: 'Fragetext',
    builderQuestionTextPlaceholder: 'Frage hier eingeben',
    builderIconLabel: 'Symbol',
    builderOptional: '(optional)',
    builderChangeIcon: 'Ändern',
    builderSelectIconBtn: 'Symbol auswählen',
    builderOptionsLabel: 'Optionen (max. 4 + "Nicht beobachtbar")',
    builderNoObservable: 'Nicht beobachtbar',
    builderRemoveNoObs: '"Nicht beobachtbar" entfernen',
    builderAddNoObs: '"Nicht beobachtbar" hinzufügen',
    builderAddOption: 'Option hinzufügen',
    builderMaxOptions: 'Maximal 4 Optionen erreicht',
    builderNPSInfo: 'NPS: Skala von 0 bis 10. Offene Frage, nicht den Teilnehmern zugewiesen.',
    builderOpenInfo: 'Freiraum für den Bewerter, seine Antwort zu schreiben.',
    builderCampaignWeight: 'Kampagnengewichtung',
    builderAdminGlobalOnly: 'Nur General-Admin',
    builderCampaignWeightSub: 'Höhere Gewichtung = höhere Priorität, wenn mehrere Umfragen aktiv sind. Nur der General-Admin kann dies ändern.',
    builderWeightBase: 'Basisgewichtung (1–10)',
    builderWeightVeryLow: 'Sehr niedrig',
    builderWeightLow: 'Niedrig',
    builderWeightMedium: 'Mittel',
    builderWeightHigh: 'Hoch',
    builderWeightVeryHigh: 'Sehr hoch',
    builderBoostUrgent: 'Dringender Boost',
    builderBoostUrgentSub: 'Hebt diese Umfrage vorübergehend über alle anderen',
    builderBoostDays: 'Tage',
    builderBoostActiveDays: 'Tag',
    builderBoostActiveMsg: 'Boost aktiv — diese Umfrage hat maximale Priorität für',
    builderNoBoostMsg: 'Kein aktiver Boost — Priorität gemäß Basisgewichtung',
    builderParticipantsTitle: 'Zu bewertende Teilnehmer',
    builderParticipantsSub: 'Definieren Sie, wie viele Personen pro Umfrage bewertet werden. Minimum für Anonymität und Maximum zur Vermeidung von Überlastung.',
    builderMinParticipantsLabel: 'Mindestteilnehmerzahl',
    builderMinParticipantsHint: 'Mind. zur Gewährleistung der Anonymität',
    builderMaxParticipantsLabel: 'Maximale Teilnehmerzahl',
    builderMaxParticipantsHint: 'Max. zu bewertende Personen pro Umfrage',
    builderPrivacyTitle: 'Datenschutz und Anonymität',
    builderPrivacySub: 'Definieren Sie, ob Feedback mit der Identität des Befragten verknüpft wird.',
    builderEnableAnonymity: 'Anonymität aktivieren',
    builderAnonymityDesc: 'Feedback enthält keinen Benutzernamen — nur Antwort und Uhrzeit',
    builderTranslationsTitle: 'Übersetzungen',
    builderTranslationsEuropeSub: 'Europa-Zielgruppe — alle 6 Sprachen erforderlich. Verwenden Sie den Schalter zum Aktivieren oder Deaktivieren einer Sprache.',
    builderTranslationsSub: 'Übersetzung ins Englische ist mindestens erforderlich. Verwenden Sie den Schalter, um weitere Sprachen zu aktivieren.',
    builderAutoTranslateNote: 'Übersetzungen werden automatisch mit Azure Translator generiert. Überprüfen und passen Sie jeden Bereich nach Bedarf an.',
    builderLangNotApplicable: 'Nicht anwendbar',
    builderLangComplete: 'Fertig',
    builderLangPending: 'Ausstehend',
    builderLangRequired: 'Erforderlich',
    builderLangOptional: 'Optional',
    builderAutoTranslateBtn: 'Auto-Übersetzen',
    builderAutoTranslating: 'Übersetzung läuft…',
    builderAutoTranslateError: 'Die automatische Übersetzung ist fehlgeschlagen. Bitte erneut versuchen.',
    sessionExpiredError: 'Deine Sitzung ist abgelaufen. Bitte lade die Seite neu und melde dich erneut an.',
    builderSourceLangLabel: 'Ausgangssprache',
    builderSourceLangHint: 'Die Sprache, in der Sie diese Frage verfassen. Die anderen Sprachen werden im Abschnitt Übersetzungen als Übersetzung angefordert.',
    builderLangApplies: 'Gilt',
    builderLangDoesNotApply: 'Gilt nicht',
    builderTrlName: 'Name:',
    builderTrlDesc: 'Beschreibung:',
    builderTrlEmpty: 'leer',
    builderLangDisabled: 'Diese Sprache ist für diese Umfrage deaktiviert.',
    builderReviewTitle: 'Überprüfen und veröffentlichen',
    builderReviewTemplateTitle: 'Vorlage überprüfen',
    builderEuropaPublishNote: 'Europa-Modus: unabhängige Kampagne wegen DSGVO. Denken Sie daran, die Genehmigung der OE Europa einzuholen.',
    builderPublishIdLabel: 'Bezeichner',
    builderPublishInternal: '(intern)',
    builderPublishTypeLabel: 'Typ',
    builderPublishAudienceLabel: 'Zielgruppe',
    builderPublishQuestionsLabel: 'Fragen',
    builderPublishActiveDaysLabel: 'Aktive Tage',
    builderPublishExpirationLabel: 'Ablauf',
    builderPublishAnonymityLabel: 'Anonymität',
    builderPublishAnonymousVal: 'Anonym',
    builderPublishNominalVal: 'Nominal',
    builderCompleteBeforePublish: 'Vor dem Veröffentlichen ausfüllen:',
    builderCompleteBeforeSave: 'Vor dem Speichern ausfüllen:',
    builderReadyToPublish: 'Alles bereit. Klicken Sie auf Umfrage veröffentlichen, um sie zu aktivieren.',
    builderReadyToSaveTemplate: 'Alles bereit. Klicken Sie auf Vorlage speichern, um sie zu speichern.',
    builderIconCatalogTitle: 'Symbolkatalog',
    builderSystemIcons: 'Systemsymbole',
    builderNoIcon: 'Kein Symbol',
    builderMyCatalog: 'Mein Katalog',
    builderDeleteFromCatalog: 'Aus Katalog löschen',
    builderCatalogEmpty: 'Ihr Katalog ist leer — laden Sie ein Symbol hoch und speichern Sie es hier',
    builderUploadIcon: 'Neues Symbol hochladen',
    builderIconNamePlaceholder: 'Symbolname (z.B. Innovation)',
    builderSelectFile: 'Datei auswählen',
    builderInvalidFormat: 'Ungültiges Format. Verwenden Sie SVG oder PNG mit transparentem Hintergrund.',
    builderFileTooLarge: 'Datei zu groß. Maximal 200 KB.',
    builderCustomIcon: 'Benutzerdefiniertes Symbol',
    builderSaveForReuse: 'Im Katalog zur Wiederverwendung speichern',
    builderUseIcon: 'Symbol verwenden',
    builderIconHelp: 'SVG oder PNG, transparenter Hintergrund, 512×512 px empfohlen, max. 200 KB',
    builderPreviewCompleteStep1: 'Füllen Sie die Daten in Schritt 1 aus, um die Vorschau zu sehen',
    builderPreviewClickToEdit: 'Klicken Sie auf einen beliebigen Text zum Bearbeiten',
    builderPreviewNoQuestions: 'Fragen erscheinen hier in Schritt 3',
    builderPreviewGeneral: 'Allgemein',
    builderPreviewPersonalized: 'Personalisiert',
    builderPreviewPulsoEspecifica: 'Spezifischer Puls',
    builderPreviewChangeIcon: 'Symbol ändern',
    builderPreviewIndividual: 'Individuell',
    builderPreviewCollective: 'Kollektiv',
    builderPreviewModeIndividual: 'Individuell',
    builderPreviewModeMatrix: 'Allgemeine Matrix',
    builderPreviewMissingTranslation: '(keine Übersetzung)',
    builderPreviewWriteAnswer: 'Schreiben Sie Ihre Antwort hier...',
    builderPreviewNoObs: 'Nicht beobachtbar',
    builderPreviewNA: 'N/A',
    builderNavInfo: 'Info',
    builderNavAudiencia: 'Zielgruppe',
    builderNavPreguntas: 'Fragen',
    builderNavConfig: 'Einstellungen',
    builderNavPublicar: 'Veröffentlichen',
    builderNavGuardar: 'Speichern',
    builderInfoTitle: 'Grundlegende Informationen',
    builderSelectAll: 'Alle auswählen',
    langEn: 'Englisch',
    langDe: 'Deutsch',
    langPt: 'Portugiesisch',
    langFr: 'Französisch',
    langNl: 'Niederländisch',
    langRo: 'Rumänisch',
    builderTrlPlaceholderIn: 'auf',
    builderTrlPlaceholderOpt: 'Option',
    builderTrlNoText: 'Noch kein Text',
    // New keys added during refactor
    builderLinkedTo: 'Verknüpft mit',
    builderSelectedIcon: 'Ausgewählt',
    builderHidePreview: 'Vorschau ausblenden',
    builderShowPreview: 'Vorschau anzeigen',
    builderPreviewMorePersons: 'weitere Personen',
    builderPreviewOption1: 'Option 1',
    builderPreviewOption2: 'Option 2',
    builderPreviewViewIn: 'Anzeigen in:',
    builderFromOU: 'aus',
    builderWillReceiveSurvey: 'erhalten diese Umfrage',
    builderPersonsCount: 'Personen',
    builderPersonsPlural: 'Personen',
    builderPersonSingular: 'Person',
    builderInternalIdPlaceholder: 'Z.B. Grundlagen Q1 2026',
    builderMeetingIdPlaceholder: 'Z.B. 19:meeting_abc123@thread.v2',
    builderOptionDefault: 'Option',
    builderRemovePerson: 'Entfernen',
    builderSaveTemplateMock: 'Als Vorlage gespeichert ✓',
    builderPublishGlobalLabel: 'Global (exkl. Europa)',
    builderTypeRating: 'Bewertung (1-4)',
    builderTypeMultiple: 'Mehrfachauswahl',
    builderTypeOpen: 'Offene Frage',
    builderTypeBehaviors: 'Verhaltensweisen',
    builderTypeNPS: 'NPS (1-10)',
    // System tab
    systemTab: 'System',
    // Monitor tab
    monitorTab: 'Überwachung',
    // Trace tab
    traceTab: 'Rückverfolgbarkeit',
    // Jobs tab
    jobsTab: 'Jobs',
    frontlineUsersTab: 'Benutzerverwaltung',
  },
  // Gestión de usuarios Frontline (Admin General): correos personales y verificación.
  frontlineUsers: {
    title: 'Benutzerverwaltung',
    subtitle: 'E-Mails und Verifizierung der Benutzer. Konten aus dem AD sind schreibgeschützt.',
    tableTitle: 'E-Mails und Passwörter',
    notice: 'AD-Konten sind schreibgeschützt: Ihre Firmen-E-Mail stammt aus dem Verzeichnis. Bei den übrigen wird die persönliche E-Mail bearbeitet, die die Person verifizieren muss, um sich anzumelden und ihr Passwort zurückzusetzen.',
    search: 'Nach Personalnummer, Name oder E-Mail suchen...',
    ouAll: 'OU: Alle',
    ouAllMine: 'OU: Alle meine OUs',
    siteAll: 'Standort: Alle',
    segment: 'Personalart',
    segmentAll: 'Art: Alle',
    segmentOption: { Staff: 'Staff', Frontline: 'Frontline' },
    stateAll: 'Verifizierung: Alle',
    hideInactive: 'Inaktive ausblenden',
    export: 'CSV exportieren',
    exporting: 'Export läuft...',
    exportTruncated: 'Die Datei ist unvollständig: Das Zeilenlimit wurde erreicht. Filter einschränken und erneut exportieren.',
    exportError: 'Die Datei konnte nicht exportiert werden.',
    colPayroll: 'Personalnummer',
    colName: 'Vollständiger Name',
    colCorp: 'Firmen-E-Mail',
    colPersonal: 'Persönliche E-Mail',
    colOu: 'OU',
    colSite: 'Standort',
    colStatus: 'Status',
    statusActive: 'Aktiv',
    statusInactive: 'Inaktiv',
    colAction: 'Aktion',
    colSend: 'Verifizierung senden',
    colState: 'Verifizierung',
    chipVerified: '{{count}} verifiziert',
    chipPending: '{{count}} Verifizierung ausstehend',
    chipNotSent: '{{count}} nicht gesendet',
    chipNoEmail: '{{count}} nicht registriert',
    ssoRiskWarn: 'Dieser Datensatz hat eine Firmen-E-Mail: Meldet sich die Person per SSO an, kann eine Änderung den Zugang sperren. Vor dem Speichern prüfen.',
    chipDirectory: '{{count}} aus dem AD',
    state: {
      Verificado: 'Verifiziert',
      Pendiente: 'Verifizierung ausstehend',
      NoEnviado: 'Nicht gesendet',
      SinCorreo: 'Nicht registriert',
      DelDirectorio: 'Aus dem AD',
    },
    sentOn: 'Gesendet {{date}}',
    send: 'Senden',
    resend: 'Erneut senden',
    noEmailTitle: 'Keine persönliche E-Mail',
    verifiedTitle: 'Die E-Mail ist bereits verifiziert',
    sendTitle: 'Verifizierungs-E-Mail senden',
    sentOk: 'Verifizierungs-E-Mail an {{email}} gesendet.',
    empty: 'Keine Benutzer entsprechen der Suche.',
    editLabel: '{{name}} bearbeiten',
    verifLabel: 'Verifizierungsdetails von {{name}} anzeigen',
    editTitle: 'Benutzer bearbeiten — {{name}}',
    corpHelp: 'Schreibgeschützt. Diese E-Mail wird aus SAP synchronisiert.',
    corpNone: 'Keine Firmen-E-Mail in SAP',
    corpLoginHelp: 'Nur Lesen. Mit dieser E-Mail-Adresse meldet sich die Person derzeit an.',
    personalReplaceHelp: 'Leer lassen, um die Firmen-E-Mail beizubehalten. Soll sich die Person mit einer anderen Adresse anmelden, hier eintragen: Sie ersetzt die aktuelle.',
    ssoAccessHelp: 'Diese Person meldet sich mit ihrem Firmenkonto (SSO) an: Es wird keine private E-Mail-Adresse hinzugefügt und kein Link gesendet.',
    noLicenseTag: 'Keine Lizenz',
    noLicenseCorp: 'Keine Lizenz: muss sich registrieren',
    helpChange: 'Nach dem Speichern muss diese E-Mail erneut verifiziert werden.',
    helpClear: 'Nach dem Speichern hat der Benutzer keine persönliche E-Mail.',
    helpVerified: 'E-Mail verifiziert.',
    helpDefault: 'Mit dieser E-Mail meldet sich die Person an und setzt ihr Passwort zurück.',
    saved: 'Änderungen für {{name}} gespeichert.',
    pw: {
      title: 'Passwort',
      lastChange: 'Letzte Änderung: {{date}}.',
      noRecord: 'Es liegt kein Datum der letzten Passwortänderung vor.',
      tempPending: 'Es gibt ein ungenutztes temporäres Passwort; es läuft am {{date}} ab.',
      sendLink: 'Link an die persönliche E-Mail senden',
      sendActivation: 'Aktivierungslink senden',
      unclaimedNote: 'Dieser Datensatz hat noch kein Konto: Der Weg ist der Aktivierungslink (derselbe wie bei der Registrierung). Ein temporäres Passwort gilt nur für bereits beanspruchte Konten.',
      linkSent: 'Link an {{email}} gesendet.',
      needsVerified: 'Verfügbar, sobald die persönliche E-Mail verifiziert ist.',
      needsEmail: 'Füge eine persönliche E-Mail-Adresse hinzu, um den Aktivierungslink zu senden.',
      generate: 'Temporäres Passwort generieren',
      forceChange: 'Beim nächsten Anmelden eine Passwortänderung verlangen',
      generateNote: 'Das temporäre Passwort wird nicht per E-Mail versendet: Es wird nur einmal angezeigt, damit du es der Person übergeben kannst.',
      expiryHint: 'Das temporäre Passwort läuft nach 7 Tagen ab; danach muss ein neues erzeugt werden.',
      confirmTitle: 'Temporäres Passwort generieren?',
      confirmMsg: 'Das aktuelle Passwort dieser Person funktioniert sofort nicht mehr und offene Links zum Zurücksetzen werden ungültig. Das neue wird nur einmal angezeigt.',
      shownOnce: 'Wird nur dieses eine Mal angezeigt. Geben Sie es der Person, bevor Sie dieses Fenster schließen.',
      expiresOn: 'Gültig zum Anmelden bis {{date}}; danach muss ein neues erzeugt werden.',
      noExpiry: 'Läuft nicht ab: Es ist das Passwort, das Sie für diese Person festgelegt haben.',
      copy: 'Kopieren',
      copied: 'Passwort kopiert.',
      copyFailed: 'Kopieren nicht möglich.',
    },
    err: {
      invalid: 'Geben Sie eine gültige E-Mail ein, z. B. name@gmail.com.',
      taken: 'Diese E-Mail gehört bereits zu einem anderen Konto.',
      pending: 'Die Person hat eine unbestätigte Registrierung: Die E-Mail kann erst geändert werden, wenn sie bestätigt oder sich erneut registriert.',
      required: 'Ein registriertes Konto kann nicht ohne E-Mail bleiben.',
      notFound: 'Das Konto existiert nicht mehr.',
      alreadyVerified: 'Die E-Mail ist bereits verifiziert.',
      noEmail: 'Das Konto hat keine persönliche E-Mail.',
      inactive: 'Das Konto ist deaktiviert.',
      notClaimed: 'Dieses Konto hat sich noch nicht registriert: Es wird per Aktivierungs-E-Mail aktiviert und kann nicht manuell verifiziert werden.',
      notEligible: 'Dieses Konto kann derzeit nicht aktiviert werden.',
      quota: 'An dieses Konto wurden zu viele E-Mails gesendet. Warten Sie eine Minute und versuchen Sie es erneut.',
      sendFailed: 'Die E-Mail konnte jetzt nicht gesendet werden. Versuchen Sie es in einer Minute erneut.',
      generic: 'Die Aktion konnte nicht abgeschlossen werden.',
      emailNotVerified: 'Die persönliche E-Mail ist noch nicht verifiziert: Verifizieren Sie sie zuerst.',
      directory: 'Konto aus dem AD (Mitarbeitende): Die E-Mail stammt aus dem Verzeichnis und wird hier weder bearbeitet noch aktiviert.',
      sso: 'Diese Person meldet sich mit dem Firmenkonto an (SSO): Sie wird nicht mit E-Mail und Passwort aktiviert.',
      jobFunction: 'Die Stelle dieser Person ist nicht zur Registrierung mit E-Mail und Passwort berechtigt.',
      ouBlocked: 'Die OU dieser Person erlaubt derzeit keine Registrierung.',
      adminRecord: 'Dies ist ein Administratoreintrag: Er kann sich so nicht registrieren.',
    },
    verTitle: 'Verifizierung — {{name}}',
    history: 'Verlauf',
    noEvents: 'Keine Aktivität',
    markVerified: 'Als verifiziert markieren',
    markTitle: 'Als verifiziert markieren?',
    markMsg: 'Die E-Mail gilt als verifiziert, ohne dass die Person den Link öffnet. Die Aktion wird unter Ihrem Namen im Verlauf erfasst.',
    markedOk: '{{name}} ist jetzt verifiziert.',
    markUnclaimedTitle: 'Dieses Konto hat sich noch nicht registriert: Es wird per Aktivierungs-E-Mail aktiviert.',
    verResend: 'Verifizierung erneut senden',
    eventBy: 'von {{name}}',
    event: {
      VerificacionEnviada: 'Verifizierung gesendet',
      VerificacionReenviada: 'Verifizierung erneut gesendet',
      CorreoVerificadoPorUsuario: 'E-Mail von der Person verifiziert',
      CorreoActualizado: 'Persönliche E-Mail aktualisiert',
      VerificadoManualmente: 'Manuell von einem Administrator verifiziert',
      EnlaceRestablecimientoEnviado: 'Link zum Zurücksetzen des Passworts gesendet',
      PasswordTemporalGenerada: 'Temporäres Passwort generiert',
    },
  },
  jobs: {
    title: 'Synchronisierung des Personalstamms',
    subtitle: 'Woher Benutzer und Organisationseinheiten kommen, der Katalog der Unternehmensdomänen und der Status jedes Durchlaufs.',
    ouCatalogSync: 'OU-Synchronisierung',
    userCatalogSync: 'Benutzersynchronisierung',
    statusNeverRun: 'Nie ausgeführt',
    statusRunning: 'Läuft…',
    statusSuccess: 'Erfolg',
    statusSkipped: 'Übersprungen',
    statusFailed: 'Fehler',
    lastRun: 'Letzte Ausführung',
    duration: 'Dauer',
    triggerScheduled: 'Automatisch',
    triggerManual: 'Manuell',
    created: 'Erstellt',
    updated: 'Aktualisiert',
    unchanged: 'Unverändert',
    skipReason: 'Grund',
    errorMessage: 'Fehler',
    nextScheduled: 'Nächste automatische Ausführung',
    nextScheduledUnknown: 'Wird nach dem ersten Lauf berechnet',
    padronTitle: 'Verzeichnis',
    padronTotal: 'Datensätze gesamt',
    padronUnclaimed: 'Nicht beansprucht',
    padronLoading: 'Wird gezählt…',
    padronError: 'Verzeichnis konnte nicht gelesen werden.',
    padronHint: 'Ein nicht beanspruchter Datensatz gehört zu einer Person, die sich noch nie angemeldet hat. Sie erscheint nicht in den Verwaltungslisten.',
    identity: "Zählerabgleich",
    identityOk: "Stimmt",
    identityBad: "Stimmt NICHT: {{suma}} vs {{recibidas}}",
    drift: "Zählabweichung",
    duplicateEmail: "Doppelte E-Mails in der Quelle",
    ouSubidaARaiz: "Auf ihre Wurzeleinheit angehobene Datensätze",
    ouHuerfanaResuelta: "Nach Region aufgelöste fehlende Einheiten",
    ouHuerfanaSinResolver: "NICHT aufgelöste defekte Einheiten",
    managerLinks: "Vorgesetzte aufgelöst",
    licenseDiscarded: "Konten ohne zulässige Lizenz",
    practicantesIncluded: "Praktikanten aufgenommen",
    practicantesSinRegion: "Praktikanten ohne Region (extensionAttribute12)",
    practicantesDeactivated: "Praktikanten deaktiviert",
    licenseDemotionCandidates: "Würden auf Frontline wechseln (Lizenz)",
    licenseDemoted: "Auf Frontline gewechselt (Lizenz)",
    runNow: 'Jetzt ausführen',
    runningDisabled: 'Läuft bereits',
    viewHistory: 'Verlauf anzeigen',
    hideHistory: 'Verlauf ausblenden',
    historyEmpty: 'Noch keine Ausführungen aufgezeichnet.',
    historyLoading: 'Verlauf wird geladen…',
    historyError: 'Verlauf konnte nicht geladen werden.',
    colDate: 'Datum',
    colTrigger: 'Auslöser',
    colStatus: 'Status',
    colDuration: 'Dauer',
    colDetail: 'Detail',
    triggerError: 'Job konnte nicht ausgeführt werden.',
    triggerConflict: 'Der Job läuft bereits — bitte warten, bis er fertig ist.',
    tabs: {
      users: 'Benutzer',
      ous: 'Organisationseinheiten',
      domains: 'Domänen (Excel)',
      sentinels: 'Ignorierte E-Mails (SF)',
      delegation: 'Im Namen von',
    },
    runsTitle: 'Durchläufe',
    noJobs: 'Für diesen Bereich sind keine Durchläufe erfasst.',
    sfUserSync: 'Benutzer (SuccessFactors)',
    sfOuSync: 'Organisationseinheiten (SuccessFactors)',
    adDomainSweep: 'Domänenabgleich des Verzeichnisses',
    cuentasBarridas: 'Geprüfte aktive Konten',
    dominiosObservados: 'Beobachtete Domänen',
    dominiosNoDeclarados: 'Beobachtet, aber nicht deklariert',
    dominiosDesaparecidos: 'Deklariert, aber nicht mehr beobachtet',
    dominiosDesactivados: 'Deaktivierte Domänen',
    sync: {
      title: 'Datenquelle',
      desc: 'Woher der Personalstamm der Mitarbeitenden kommt.',
      users: 'Quelle der Benutzer',
      adOnly: 'Nur Active Directory',
      adOnlyHint: 'Die Mitarbeitenden mit Unternehmenskonto kommen aus dem AD. SuccessFactors läuft weiter, aber nur für Mitarbeitende ohne Unternehmenspostfach: sie stehen nicht im AD und kämen sonst nie herein.',
      apiOnly: 'Nur SuccessFactors',
      apiOnlyHint: 'Der gesamte Personalstamm kommt aus SuccessFactors, auch die Mitarbeitenden mit Unternehmenskonto. Der AD-Durchlauf wird übersprungen.',
      adThenApi: 'AD und danach SuccessFactors',
      adThenApiHint: 'Beide laufen. SuccessFactors füllt nur, was das AD leer gelassen hat; die einzige Ausnahme ist das Land, das immer von SuccessFactors geschrieben wird.',
      ous: 'Organisationseinheiten',
      ousDesc: 'Woher der Baum der Organisationseinheiten kommt.',
      ouSource: 'Quelle des Baums',
      ouAd: 'Active Directory',
      ouApi: 'SuccessFactors',
      sf: 'SuccessFactors',
      sfEnabled: 'Synchronisierung aktiviert',
      dryRun: 'Simulationsmodus',
      dryRunHint: 'Der Durchlauf zählt alles und meldet die Ergebnisse, schreibt aber KEINE Änderungen. Für die erste Ausführung ist dies der empfohlene Modus.',
      sfOn: 'Aktiviert',
      sfOff: 'Aus',
      sfDryRun: 'Aktiviert, im Simulationsmodus',
      sfManagedInUsers: 'Wird im Reiter Benutzer eingestellt: dieselben Schalter steuern beide Durchläufe.',
      domains: 'Zugelassene Unternehmensdomänen — Excel-Massenimport',
      domainsDesc: 'Gilt NUR für den Excel-Massenimport für Europa und die USA. Wird eine Domäne hinzugefügt, melden sich die Personen aus der Datei mit dieser Adresse per SSO an und können sich nicht mehr registrieren. Wird eine entfernt, wird ihre Adresse beim Import ignoriert und diese Personen müssen bei der Registrierung ihre eigene angeben. Die Synchronisierung mit Active Directory und SuccessFactors ist nicht betroffen.',
      domainsHint: 'Eine pro Zeile oder durch Kommas getrennt.',
      domainsCount: '{{n}} Domänen',
      domainBadFormat: 'sieht nicht wie eine Domäne aus (auf Leerzeichen, At-Zeichen oder Pfade prüfen)',
      domainDuplicate: 'doppelt: wird nur einmal gespeichert',
      domainsRemoved: 'Wird ENTFERNT',
      domainsRemovedWarning: 'Deren Mitarbeitende melden sich nicht mehr per SSO an und können sich mit Passwort registrieren.',
      domainsAdded: 'Wird HINZUGEFÜGT',
      domainsAddedWarning: 'Deren Mitarbeitende müssen sich per SSO anmelden und können sich nicht registrieren.',
      domainsReview: 'Prüfen und speichern',
      domainsConfirm: 'Änderung bestätigen',
      domainsCancel: 'Abbrechen',
      domainsAllInvalid: 'Keine gültige Domäne: eine leere Liste kann nicht gespeichert werden.',
      domainsSaved: 'Domänenkatalog gespeichert.',
      saved: 'Einstellungen gespeichert.',
      loadError: 'Die Quellen-Einstellungen konnten nicht gelesen werden.',
      updatedBy: 'Letzte Änderung von',
      errSession: 'Die Sitzung ist abgelaufen. Melden Sie sich erneut an und wiederholen Sie die Änderung.',
      errForbidden: 'Sie haben keine Berechtigung, diese Einstellungen zu speichern: die Rolle AdminGlobal ist erforderlich.',
      errValidation: 'Die Einstellungen haben die Prüfung nicht bestanden: {{detalle}}',
      errValidationPlain: 'Die Einstellungen haben die serverseitige Prüfung nicht bestanden.',
      errOther: 'Speichern nicht möglich (Fehler {{status}}). Wenn es erneut auftritt, muss das Dienstprotokoll geprüft werden.',
      errNetwork: 'Speichern nicht möglich: keine Antwort vom Server. Prüfen Sie die Verbindung und versuchen Sie es erneut.',
      sentinels: 'Ignorierte E-Mails aus SuccessFactors',
      sentinelsDesc: 'Gilt NUR für die SuccessFactors-Synchronisierung. Es ist der Text, den die Quelle in das E-Mail-Feld schreibt, wenn die Person KEINE E-Mail hat. Es sind keine Adressen: verglichen wird nur der Teil vor dem @, deshalb deckt „nomail“ auch nomail@jede-domäne ab. Wird ein Eintrag entfernt, wird dieser Text als echte Adresse gespeichert: die Person gilt als Unternehmensmitarbeiter, kann sich nicht mehr registrieren, und der Durchlauf kann an einer doppelten E-Mail scheitern.',
      sentinelsHint: 'Einer pro Zeile. Vollständige Adressen können eingefügt werden: gespeichert wird nur der Teil vor dem @.',
      sentinelsCount: '{{n}} Einträge',
      sentinelBadFormat: 'sieht nicht wie ein gültiger Postfachname aus (auf Leerzeichen oder ungewöhnliche Zeichen prüfen)',
      sentinelNormalized: 'wird als „{{valor}}“ gespeichert und deckt diesen Namen damit bei JEDER Domäne ab',
      sentinelsRemovedWarning: 'Dieser Text wird wieder als echte Adresse gespeichert. Teilen ihn zwei Personen, scheitert der Durchlauf an einer doppelten E-Mail.',
      sentinelsAddedWarning: 'Wer diesen Text mitbringt, gilt künftig als „ohne E-Mail“ und muss sich registrieren.',
      sentinelsSaved: 'Liste der ignorierten E-Mails gespeichert.',
      sentinelsEmpty: 'Die Liste darf nicht leer bleiben: ohne Einträge würden die Platzhalter-E-Mails der Quelle als echte Adressen gespeichert und der Durchlauf würde scheitern.',
      delegation: '„Im Namen von“: ausgeschlossene Jobfamilien',
      delegationDesc: 'Legt fest, wer im Feld „Im Namen einer anderen Person“ und im CSV-Massenupload als Absender erscheinen kann: nur operatives Personal derselben Einheit wie die Person, die es nutzt. Jobfamilien auf dieser Liste erscheinen nicht; Personen ohne Jobfamilie erscheinen nur, wenn sie keine Firmen-E-Mail haben. Empfänger werden nicht eingeschränkt.',
      delegationEnabled: 'Regel „Im Namen von“ anwenden',
      delegationEnabledHint: 'Ausgeschaltet funktionieren das Feld und der Massenupload wie bisher, und die Liste hat keine Wirkung. Änderungen gelten sofort, ohne Deployment.',
      delegationHint: 'Ausgeschlossene Jobfamilien-Codes (SuccessFactors), einer pro Zeile.',
      delegationCount: '{{n}} ausgeschlossene Familien',
      delegationBadFormat: 'ist kein Jobfamilien-Code: nur Ziffern erlaubt (z. B. 50000117)',
      delegationEmpty: 'Ohne ausgeschlossene Familien wird nur nach Einheit gefiltert sowie nach Personen ohne Jobfamilie mit Firmen-E-Mail.',
      delegationTurnOn: 'Die Regel wird eingeschaltet: Feld und Massenupload akzeptieren als Absender nur operatives Personal derselben Einheit.',
      delegationTurnOff: 'Die Regel wird ausgeschaltet: Jede aktive Person kann wieder als Absender gewählt werden.',
      delegationRemovedWarning: 'Diese Familie erscheint wieder als Absender.',
      delegationAddedWarning: 'Diese Familie erscheint nicht mehr als Absender.',
      delegationSaved: 'Regel „Im Namen von“ gespeichert.',
      adRules: 'Regeln der AD-Synchronisierung',
      adRulesDesc: 'Aktive Lizenz, Aufnahme und Deaktivierung von Praktikanten sowie Wechsel auf Frontline bei Lizenzverlust. Die ersten drei sind anfangs aus, die vierte auf „Nur Bericht“: nacheinander einschalten, zuerst auf „Nur Bericht“ (zählt, wen es betreffen würde, ohne jemanden zu ändern) und dann auf „Anwenden“.',
      adRulesSave: 'Regeln speichern',
      adRulesConfirm: 'Bestätigen und speichern',
      adRulesConfirmEnforce: 'Eine Regel steht auf „Anwenden“: Sie entscheidet, wer in den Personalstamm aufgenommen wird oder ihn verlässt. Prüfen Sie vor dem Bestätigen die Zahlen aus dem Modus „Nur Bericht“.',
      adRulesSaved: 'Regeln gespeichert.',
      modeOff: 'Aus',
      modeOffHint: 'Die Regel wird nicht angewendet.',
      modeReportOnly: 'Nur Bericht',
      modeReportOnlyHint: 'Zählt, wen es betreffen würde, ohne jemanden zu ändern. Die Zahlen erscheinen auf der Karte des Durchlaufs.',
      modeEnforce: 'Anwenden',
      modeEnforceHint: 'Wendet die Regel an. Lizenz und Deaktivierung haben eine Schutzgrenze: Wären zu viele Konten betroffen, nimmt der Durchlauf keine Änderungen vor.',
      license: 'Aktive Lizenz',
      licenseDesc: 'Nur aktivierte Konten mit einer der zulässigen Lizenzen (E3, E5, F3 oder F1) werden in den Personalstamm aufgenommen. Feste Konten sind ausgenommen.',
      licenseSkus: 'Zulässige Lizenzen (SkuId)',
      licenseSkusHint: 'Eine pro Zeile. Es ist die SkuId (eine GUID) aus Get-MgSubscribedSku, nicht der Name.',
      licenseSkusCount: 'Lizenzen: {{n}}',
      licenseSkuBad: 'ist keine gültige SkuId (muss eine GUID sein, nicht der Name „E3“)',
      licenseSkusEmpty: 'Bei aktivierter Lizenzregel darf die Liste nicht leer sein: Geben Sie an, welche Lizenzen (E3, E5, F3, F1) zählen.',
      licenseMax: 'Obergrenze für wegen der Lizenz ausgeschlossene Konten (%)',
      licenseMaxHint: 'Würde die Lizenz mehr als diesen Prozentsatz ausschließen, nimmt der Durchlauf keine Änderungen vor: Wahrscheinlich ist die Lizenzliste falsch.',
      percentInvalid: 'Muss eine ganze Zahl zwischen 1 und 100 sein.',
      practicantes: 'Aufnahme von Praktikanten',
      practicantesDesc: 'In den Personalstamm kommen alle mit „PRACTICANTE“ in extensionAttribute10 und ihrer Region in extensionAttribute12 (MEXICO, CENTRAL, FOSE oder LATAM). Ohne Region kommen sie nicht hinein: Sie werden gezählt und kommen von selbst hinein, sobald die Angabe vorliegt.',
      deactivation: 'Deaktivierung von Praktikanten',
      deactivationDesc: 'Ein aktiver Praktikant, dessen Stellenbezeichnung mit „Practicante“ beginnt und der nicht mehr in der Synchronisierung erscheint (deaktiviertes Konto, keine zulässige Lizenz oder kein „PRACTICANTE“), wird als inaktiv markiert. Es ist ein logisches Löschen: Der Datensatz wird nicht gelöscht und nicht automatisch reaktiviert.',
      deactivationNeedsInclusion: 'Die Deaktivierung läuft nur, wenn die Aufnahme von Praktikanten auf „Anwenden“ steht. Bis dahin tut diese Regel nichts.',
      deactivationMax: 'Obergrenze der Deaktivierungen (% der aktiven Praktikanten)',
      deactivationMaxHint: 'Würde die Deaktivierung mehr als diesen Prozentsatz treffen, wird in diesem Durchlauf niemand deaktiviert: Wahrscheinlich ist der Feed abgeschnitten, keine normale Fluktuation.',
      demotion: 'Wechsel auf Frontline bei Lizenzverlust',
      demotionDesc: 'Wer vom Verzeichnis wegen fehlender Lizenz ausgeschlossen wird und von SuccessFactors weiter geliefert wird, erhält die Markierung „ohne Lizenz“; SuccessFactors stuft die Person auf Frontline um und leert die Firmen-E-Mail. Bereits beanspruchte Datensätze werden ebenfalls umgestellt (ihr Passwort wird gelöscht), außer die von Administratoren. Kehrt die Lizenz zurück, wird die Markierung automatisch entfernt.',
      demotionNeedsLicense: 'Diese Regel wirkt nur, wenn die aktive Lizenz auf „Anwenden“ steht. Solange das nicht der Fall ist, tut sie nichts.',
      demotionMax: 'Obergrenze der Umstellungen (%)',
      demotionMaxHint: 'Würde die Umstellung mehr als diesen Prozentsatz der Verzeichnispersonen mit SuccessFactors treffen, wird in diesem Durchlauf niemand umgestellt: Wahrscheinlich ist die Lizenzliste falsch geschrieben.',
    },
  },
  monitor: {
    title: 'Pipeline-Monitor',
    subtitle: 'Audit der Meeting-Eligibility-Ereignisse, die vom Regelwerk verarbeitet wurden.',
    refresh: 'Aktualisieren',
    lastFetch: 'Zuletzt abgerufen',
    loading: 'Ereignisse werden geladen…',
    timeout: 'Zeitüberschreitung',
    unknownError: 'Unbekannter Fehler',
    empty: 'Keine Pipeline-Ereignisse gefunden.',
    eligible: 'Berechtigt',
    ineligible: 'Nicht berechtigt',
    sampled: 'Ausgewählt',
    excluded: 'Ausgeschlossen',
    samplingApplied: 'Max. Stichprobenentnahme angewendet',
    noParticipants: 'Keine Teilnehmer erfasst.',
    statTotal: 'Ereignisse gesamt',
    statEligible: 'Berechtigte Meetings',
    statAvgSampled: 'Ø ausgewählte Teilnehmer',
    statAvgSampledSub: 'Pro berechtigtem Meeting',
    statSampling: 'Mit max. Stichprobe',
    statSamplingSub: 'Teilnehmerlimit angewendet',
    colMeetingId: 'Meeting-ID',
    colDate: 'Datum',
    colDuration: 'Dauer',
    colEvaluated: 'Geprüft',
    colEligible: 'Berechtigt',
    colSampled: 'Ausgewählt',
    colMaxPax: 'Max',
    colResult: 'Ergebnis',
    colUserId: 'Benutzer-ID',
    colOu: 'OU',
    colTimezone: 'Zeitzone',
    colToday: 'Heute',
    colWeek: 'Woche',
    colInterval: 'Intervall',
    colStatus: 'Status',
    colReason: 'Grund',
    colSample: 'Versand',
    instancesTitle: 'Zugewiesene Umfragen',
    instancesBtnTitle: 'Umfragen dieses Teilnehmers anzeigen',
    instancesLoading: 'Umfragen werden geladen…',
    instancesEmpty: 'Keine Umfrageinstanzen für diesen Teilnehmer in diesem Meeting gefunden.',
    instancesSurvey: 'Umfrage',
    instancesStatus: 'Status',
    instancesExpires: 'Läuft ab',
    instancesDownload: 'JSON herunterladen',
    instancesClose: 'Schließen',
    sortAsc: 'Aufsteigend sortieren',
    sortDesc: 'Absteigend sortieren',
    recalculate: 'Antworten neu berechnen',
    recalculateTitle: 'Antwortanzahl für alle Umfragen neu berechnen',
    recalculateSuccess: 'Neuberechnung abgeschlossen: {{count}} Umfrage(n) aktualisiert.',
    recalculateError: 'Fehler bei der Neuberechnung der Antworten.',
    cacheTitle: 'OU-Katalog-Cache',
    cacheLoading: 'Cache wird geprüft…',
    cacheError: 'Der OU-Cache-Status konnte nicht abgerufen werden.',
    cachePopulated: 'Befüllt',
    cacheNotPopulated: 'Nicht befüllt',
    cacheOuCount: 'OUs im Cache',
    cacheLastSynced: 'Letzte Synchronisierung',
    cacheNeverSynced: 'Nie synchronisiert',
  },
  trace: {
    title: 'Pipeline-Rückverfolgbarkeit',
    subtitle: 'Vollständiger Verlauf eines Meetings, vom Anrufende bis zum Versand der Benachrichtigung.',
    filterModeLabel: 'Suchen nach',
    filterModeSubject: 'Meeting-Name',
    filterModeEmail: 'E-Mail',
    filterPlaceholderSubject: 'Z. B. Plattform-Daily',
    filterPlaceholderEmail: 'Z. B. vorname.nachname@sigma.com',
    search: 'Suchen',
    searching: 'Wird gesucht…',
    clear: 'Zurücksetzen',
    initialHint: 'Wählen Sie einen Suchmodus und geben Sie einen Suchbegriff ein, um die Rückverfolgbarkeit zu sehen.',
    invalidEmail: 'Gib eine gültige E-Mail-Adresse ein.',
    requestError: 'Die Rückverfolgbarkeit konnte nicht abgerufen werden. Bitte erneut versuchen.',
    retry: 'Erneut versuchen',
    download: 'Rückverfolgbarkeit herunterladen (JSON)',
    notFoundEmailNotRegistered: 'Diese E-Mail ist nicht als Benutzer registriert. Überprüfen Sie die Azure-AD-Synchronisierung.',
    notFoundUserWithoutMeetings: 'Der Benutzer existiert, hat aber an keinem erfassten Meeting teilgenommen.',
    notFoundSubjectNoMatches: 'Kein Meeting entspricht diesem Namen.',
    notFoundMeetingNotFound: 'Dieses Meeting existiert nicht mehr.',
    notFoundUserDirectoryUnavailable: 'Das Benutzerverzeichnis konnte nicht abgefragt werden. Prüfe, ob UserAdminService verfügbar ist.',
    matchesTitle: 'Mehrere Meetings stimmen überein — eines auswählen',
    matchesSubject: 'Meeting',
    matchesOrganizer: 'Organisator',
    matchesStatus: 'Status',
    matchesStarted: 'Beginn',
    matchesEnded: 'Ende',
    meetingSummary: 'Meeting',
    meetingCorrelation: 'CorrelationId',
    meetingDuration: 'Dauer',
    meetingStatus: 'Status',
    warningsTitle: 'Warnungen',
    stagesTitle: 'Pipeline-Phasen',
    stageColOrder: '#',
    stageColName: 'Phase',
    stageColService: 'Dienst',
    stageColTime: 'Uhrzeit',
    stageColOutcome: 'Ergebnis',
    stageMeetingEnd: 'Meeting-Ende',
    stageMeetingEligibility: 'Meeting-Berechtigung',
    stageParticipantEligibility: 'Teilnehmerberechtigung',
    stageSurveyCreation: 'Umfrageerstellung',
    stageNotification: 'Benachrichtigungen',
    outcomeOk: 'OK',
    outcomeError: 'Fehler',
    outcomeNotEligible: 'Nicht berechtigt',
    outcomeNoData: 'Keine Daten',
    logsTitle: 'Korreliertes Rohlog',
    logsSubtitle: 'Einträge von MeetingService, SurveyService, AnalyticsService und Bot. NotificationService speichert kein Rohlog.',
    logsEmpty: 'Keine Log-Einträge für dieses Meeting. Der TTL von app_logs beträgt 24 Stunden.',
    logsFilterAll: 'Alle',
    logsFilterWarning: 'Warning und höher',
    logsFilterError: 'Nur Fehler',
    logsColTime: 'Uhrzeit',
    logsColService: 'Dienst',
    logsColLevel: 'Stufe',
    logsColMessage: 'Nachricht',
  },
  system: {
    title: 'Systemdiagnose',
    subtitle: 'Echtzeitstatus aller Backend-Microservices und Worker.',
    refreshAll: 'Alle aktualisieren',
    refresh: 'Aktualisieren',
    lastChecked: 'Zuletzt geprüft',
    checking: 'Überprüfung…',
    never: 'Nie',
    statusHealthy: 'Gesund',
    statusDegraded: 'Beeinträchtigt',
    statusError: 'Verbindungsfehler',
    showDetails: 'Prüfungen anzeigen',
    hideDetails: 'Prüfungen ausblenden',
    legendTitle: 'Status-Glossar',
    legendHealthyDesc: 'Alle internen Prüfungen des Dienstes haben korrekt geantwortet.',
    legendDegradedDesc: 'Der Dienst antwortet, aber MongoDB, Redis oder Service Bus haben einen Fehler gemeldet.',
    legendErrorDesc: 'Der Dienst konnte vom Frontend nicht erreicht werden (Timeout, CORS oder Dienst ausgefallen).',
    checkMongodb: 'MongoDB',
    checkRedis: 'Redis',
    checkServiceBus: 'Service Bus',
    checkSubscriptions: 'Abonnements',
    activeMessages: 'Aktive Nachrichten',
    deadLetterMessages: 'Dead Letter',
    environment: 'Umgebung',
    version: 'Version',
    workers: 'Workers',
    workersDesc: 'Status abgeleitet aus Service Bus-Abonnementstatistiken.',
    analyticsWorker: 'Analytics Worker',
    expirationWorker: 'Expiration Worker',
    noStats: 'Keine Abonnementstatistiken verfügbar.',
    namespace: 'Namespace',
    topic: 'Topic',
    ok: 'OK',
    error: 'Fehler',
  },
  analytics: {
    title: 'Führungs-Dashboard',
    subtitle: 'Sigma Pulse Analytics',
    bias: 'Vorurteile',
    omissions: 'Auslassungen',
    personal: 'Persönlich',
    score: 'Score',
    responses: 'Antworten',
    participants: 'Teilnehmer',
    period: 'Zeitraum',
    ou: 'Organisationseinheit',
    noData: 'Unzureichende Daten',
    completionRate: 'Abschlussrate',
    avgByCategory: 'Durchschnitt nach Kategorie',
    organization: 'Organisation',
    fundamentalsRadar: 'Grundlagen-Radar',
    heatmapOuFund: 'Heatmap — Score nach Organisationseinheit und Grundlage',
    moduleInDev: 'Modul in Entwicklung',
    executiveSubtitle: 'Executive-Ansicht',
    exec: {
      periodAll: 'Gesamter Zeitraum',
    },
    tabs: {
      summary: 'Zusammenfassung',
      fundamentals: 'Grundwerte',
      heatmap: 'Heatmap',
      orgNetwork: 'Org-Netzwerk',
      generational: 'Generational',
    },
    noScopeTitle: 'Keine Organisationseinheiten zugewiesen',
    noScopeDesc: 'Deinem Konto sind keine Organisationseinheiten zugewiesen, daher gibt es keine Berichte. Bitte den zentralen Administrator, deinen Bereich einzurichten.',
    filterBar: { allOrg: 'Gesamte Organisation', allMyScope: 'Mein gesamter Bereich', allBU: 'Alle BUs', allDept: 'Alle Abteilungen', dateFrom: 'Von', dateTo: 'Bis', allDimensions: 'Alle Verhaltensweisen', clearFilters: 'Filter zurücksetzen' },
    dimensionFilter: {
      partialScope: 'Gefiltert nach „{{dimension}}“. Rücklaufquote, Bewertende, Umfragen pro Tag und Auslassungen werden nicht nach Verhalten aufgeschlüsselt: Sie umfassen den gesamten Bereich.',
      notApplicable: 'Dieser Block wird nicht nach Verhalten aufgeschlüsselt: Er wird ohne den Filter „{{dimension}}“ angezeigt.',
    },
    kpi: { evaluations: 'Bewertungen', avgScore: 'Ø Score', responseRate: 'Antwortrate', avgPerDay: 'Ø / Tag', evaluators: 'Bewerter', scale: 'Skala 1–4', noObservables: 'nicht beobachtbar', perDay: 'Umfragen pro Tag', activeParticipants: 'aktive Teilnehmer', ofTotal: 'gesamt', evaluatedPeople_one: '{{count}} bewertete Person', evaluatedPeople_other: '{{count}} bewertete Personen', responseRateSub: 'der bereits abgeschlossenen Umfragen' },
    summary: { topBehaviors: 'Top Daily Habits', topDailyHabitsSubtitle: 'Gewohnheiten mit dem höchsten kulturellen Einfluss', oppSubtitle: 'Gewohnheiten mit dem größten Verbesserungspotenzial', opportunities: 'Verbesserungsbereiche', omissionsByUnit: 'Auslassungen nach Einheit', omissionsSubtitle: 'Auslassungsrate nach OU und BU — absteigend sortiert · Klicke auf eine OU, um ihre BUs zu sehen', downloadExcel: 'Excel herunterladen', omitType: 'Typ', omitPeople: 'Personen', omitRate: 'Auslassungsrate', noOmissions: 'Keine wesentlichen Auslassungen', percentileDistribution: 'Verteilung nach Perzentil', percentileSubtitle: 'Prozentsatz der Bevölkerung in jedem Score-Bereich', personsEvaluated: 'bewertete Personen', excellent: 'Exzellent', good: 'Gut', developing: 'In Entwicklung', attention: 'Aufmerksamkeit', fundPositioning: 'Grundwerte-Positionierung', fundPositioningDesc: 'Ranking, höchste/niedrigste Punktzahl und Nicht-Beobachtungsrate je Grundwert', highestScore: 'Höchste Punktzahl', lowestScore: 'Niedrigste Punktzahl', mostNoObs: 'Meiste Nicht-Beobachtungen', scoreByOU: 'Score nach Organisationseinheit', scoreByOUSubtitle: 'Klicke auf eine OU, um die Aufschlüsselung nach BU und Abteilung zu sehen', person: 'Person', persons: 'Personen', evaluationsCount_one: '{{count}} Bewertung', evaluationsCount_other: '{{count}} Bewertungen', behaviorPositioningDesc: 'Rangliste nach Verhalten; Fundamentals ohne konfigurierte Verhaltensweisen werden als Ganzes angezeigt', behaviorColumn: 'Verhalten', distribution: 'Verteilung', omittedSurveys: 'Ausgelassen' },
    fundamentals: { title: 'Score nach Grundwert', subtitle: 'Erweitern Sie jeden Grundwert, um seine Daily Habits und die Aufschlüsselung nach OU zu sehen', evalLabel: 'Bew', confPreliminary: 'Vorläufige Daten', confBasedOn: 'Basierend auf {{n}} Bew', behaviorSubtitle: 'Jedes Fundamental gliedert sich in seine Verhaltensweisen; eine aufklappen, um ihre Daily Habits zu sehen', noObsCount_one: '{{count}} Umfrage hat es nicht bewertet', noObsCount_other: '{{count}} Umfragen haben es nicht bewertet', dailyHabits: 'Daily Habits' },
    heatmap: { title: 'Kulturelle Heatmap', subtitle: 'Tippe auf eine Zeile, um ihre Untereinheiten zu erkunden', unit: 'Einheit', unitOU: 'Organisationseinheit', unitBU: 'Business Unit', unitDept: 'Abteilung', unitPerson: 'Verantwortlicher', allOrg: 'Gesamte Organisation', hint: 'Tippe auf eine Zeile, um die nächste Ebene zu erkunden →', person: 'Person', persons: 'Personen', legendCritical: 'Kritisch', legendLow: 'Niedrig', legendMedium: 'Mittel', legendGood: 'Gut', legendExcellent: 'Ausgezeichnet', noOu: 'Ohne OU', behaviorSubtitle: 'Score nach Organisationseinheit und Verhalten; eine Zeile antippen, um ihre Untereinheiten zu erkunden', directlyAssigned: '{{ou}} direkt zugeordnet', hideEmpty_one: '{{count}} Einheit ohne Daten ausblenden', hideEmpty_other: '{{count}} Einheiten ohne Daten ausblenden', personCount_one: '{{count}} Person', personCount_other: '{{count}} Personen' },
    ona: { title: 'Org-Netzwerk (ONA)', subtitle: 'Interaktiver Baum der Organisationseinheiten (OU)', treeHint: 'Erweitern Sie jeden Knoten, um die OU-Ebenen der Organisation zu navigieren.', omissions: 'Auslassungen', totalPeople: 'Personen', avgScore: 'Ø Score', totalEvals: 'Bewertungen gesamt', collaboratorsKpi: 'Mitarbeiter', highestOmission: 'Höchste Auslassung', omissionsRanking: 'Auslassungs-Ranking', maturityCulture: 'Kulturelle Reife', maturityLegend: 'Reifegradlegende', maturityInitial: 'Initial', maturityGrowing: 'Wachsend', maturityConsolidated: 'Konsolidiert', maturityRoleModel: 'Vorbild', evalsLabel: 'Bewertungen', noEvals: 'Keine Bewertungen', collaboratorsLabel: 'Mitarbeiter', omissionLabel: 'Auslassung', evalsShort: 'Bew', omittedCount_one: '{{count}} ausgelassen', omittedCount_other: '{{count}} ausgelassen', directlyAssigned: 'Direkt zugeordnet', collaboratorsCount_one: '{{count}} Mitarbeiter', collaboratorsCount_other: '{{count}} Mitarbeitende', typeBu: 'BU', typeDept: 'Abt.', typePerson: 'Person' },
    gen: { panorama: 'Panorama', ranking: 'Ranking', brechas: 'Lücken', avgAge: 'Durchschnittsalter', title: 'Generationsanalyse', subtitle: 'Kulturelle Verteilung und Reife nach Kohorte · {{n}} Personen zugeordnet', noRepresentation: 'Keine Repräsentation', scoreLabel: 'Score', omissionLabel: 'Auslassung', personas: 'Personen', age: 'Alter', all: 'Alle', noData: 'Keine Daten für diesen Filter', fundamental: 'Fundamental', gapCol: 'Δ Lücke', brechaNote: 'Größte Lücke: {{fund}} · Δ {{delta}} Pkt zwischen Generationen', brechaSource: 'Abweichung vom Gesamtdurchschnitt des Grundwerts in der Organisation', responseCount: '{{n}} Antworten', personasCount_one: '{{count}} Person', personasCount_other: '{{count}} Personen' },
  },
  userConfig: {
    fabTitle: 'Benutzerprofil konfigurieren',
    title: 'Benutzerprofil (Demo)',
    subtitle: 'Testmodus — simuliert Daten, die bei der Integration von Teams SSO kommen',
    nombre: 'Name',
    correo: 'E-Mail',
    ou: 'OU (Organisationseinheit)',
    do_: 'DO (Abteilung)',
    bu: 'BU (Geschäftsbereich)',
    departamento: 'Abteilung',
    puesto: 'Position',
    numeronomina: 'Mitarbeiternummer',
    role: 'Rolle',
    roleDetected: 'Erkannte Rolle',
    roleNotFound: 'E-Mail nicht gefunden — Mitarbeiter-Rolle wird verwendet',
    save: 'Profil speichern',
    namePlaceholder: 'z.B.: Ana García',
    emailPlaceholder: 'z.B.: agarcia@sigma.com',
    ouPlaceholder: 'z.B.: Technologie',
    doPlaceholder: 'z.B.: IT-Abteilung',
    buPlaceholder: 'z.B.: Deutschland',
    deptPlaceholder: 'z.B.: Softwareentwicklung',
    puestoPlaceholder: 'z.B.: Senior Software-Ingenieur',
    nominaPlaceholder: 'z.B.: 123456',
    fechaNacimiento: 'Geburtsdatum',
    tenant: 'Mandant',
  },
  errors: {
    generic: 'Ein unerwarteter Fehler ist aufgetreten',
    unauthorized: 'Sie haben keine Berechtigung für diese Aktion',
    notFound: 'Ressource nicht gefunden',
    network: 'Verbindungsfehler. Überprüfen Sie Ihr Netzwerk.',
  },
  fundamentals: {
    title: 'Grundwerte',
    subtitle: 'Die Verhaltensweisen, die wir bei Sigma messen. Öffnen Sie einen, um die täglichen Gewohnheiten zu sehen.',
    habitsFor: 'Tägliche Gewohnheiten',
    otherHabits: 'Weitere Gewohnheiten',
    openHabits: 'Tägliche Gewohnheiten von {{name}} ansehen',
    openMicrosite: 'Microsite von {{name}} öffnen',
  },
};

export default de;

